


// import React, { useState, useEffect } from 'react';
// import { Modal, Form, Row, Col, Spinner, Offcanvas } from 'react-bootstrap';
// import axios from 'axios';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import Swal from "sweetalert2";
// import { use } from 'react';

// const QuotationForm = ({
//     showModal,
//     handleClose,
//     products, setProducts,
//     // fetchProducts,
//     quotationId,
//     projectId,
//     quotationData,
//     addQuotation,
//     defaultClientId,
//     editQuotation, projectName, clientName, clientCurrency, isOrder, dealData  // <-- NEW
//     // products 
// }) => {
//     console.log('cliet,project', clientCurrency, clientName, projectName);
//     const [refNo, setRefNo] = useState('');
//     const [loading, setLoading] = useState(false); // Track loading state
//     const [subscriptionPeriod, setSubscriptionPeriod] = useState(12); // Default 12 months
//     const [showSubscriptionField, setShowSubscriptionField] = useState(false);
//     const [brands, setBrands] = useState([]);
//         const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });


//     const [formData, setFormData] = useState({
//         client_id: defaultClientId || '',
//         project_id: projectId,
//         ref_no: '',
//         date: '',
//         valid_till_date: '',
//         sale_commision_type: '',
//         sale_commision: '',
//         document: '',
//         discount_amount: '',
//         discount_type: 'amount',
//         serial_no: '',
//         notes: '',
//         subscription_period: 12,
//     });
//     // console.log("Received Products:", products);

//     // console.log('proid:', projectId);
//     // console.log('clientCurrency:', clientCurrency);
//     // console.log('projectName:', projectName);
//     // console.log('clientName:', clientName);
//     // const [clientName, setClientName] = useState('');
//     // const [projectName, setProjectName] = useState('');
//     const [selectedProducts, setSelectedProducts] = useState([]);
//     const [totalAmount, setTotalAmount] = useState(0);
//     const [productsFetched, setProductsFetched] = useState(false); // Track fetch status
//     // const [clientCurrency, setClientCurrency] = useState('');
//     const [errors, setErrors] = useState({});

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const userInfo = JSON.parse(localStorage.getItem('user-info'));
//     const origin = localStorage.getItem('user-origin');
//     const token = userInfo?.token;

//     useEffect(() => {
//         if (showModal) {
//         fetchBrands();
//         fetchCategories();
//         }
//     }, []);


//     useEffect(() => {
//         if (showModal && clientCurrency && !quotationId) {
//             fetchTermsDetails(); // Now uses accurate currency
//         }
//     }, [showModal, clientCurrency, quotationId]);

//     const fetchBrands = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allBrands = [];



//             const response = await axios.get(`${backendUrl}/api/brands`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             const Brands = response.data.brand;


//             setBrands(Brands);
//         } catch (error) {
//             console.error('Error fetching brands:', error);
//         }
//     };
//      const fetchCategories = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allCategories = [];

//             const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             allCategories = [...allCategories, ...response.data.category];

//             const allCategoriesList = allCategories.filter(cat => !cat.parent_id);

//             // All subcategories (categories with parent_id)
//             const allSubcategories = allCategories.filter(cat => cat.parent_id);

//             setCategories({ allCategoriesList, allSubcategories });
//         } catch (error) {
//             console.error('Error fetching categories:', error);
//         }
//     };


//     const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);
//     const [fetchedQuotationData, setFetchedQuotationData] = useState(null);
//     // const [products, setProducts] = useState([]);
//     const fetchQuotationDetails = async () => {
//         try {
//             const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,

//             });

//             const quotation = response.data.quotation;

//             setFetchedQuotationData(quotation);
//             setFormData({
//                 client_id: quotation.client_id,
//                 project_id: quotation.project_id,
//                 ref_no: quotation.ref_no || '',
//                 date: quotation.date || '',
//                 valid_till_date: quotation.valid_till_date || '',
//                 sale_commision_type: quotation.sale_commision_type || '',
//                 sale_commision: quotation.sale_commision || '',
//                 document: quotation.document || '',
//                 discount_amount: quotation.discount_amount || '',
//                 discount_type: quotation.discount_type || 'amount',
//                 serial_no: quotation.serial_no || '',
//                 notes: quotation.notes || '',
//                 subscription_period: quotation.subscription_period || 12,
//                 total_amount_with_subscription: quotation.total_amount_with_subscription,
//                 subscription_amount: quotation.subscription_amount,
//                 deplyment_amount: quotation.deplyment_amount,
//             });

//             setSelectedProducts(
//                 quotation.product_item_details.map(item => ({
//                     product_id: item.product_id,
//                     item_name: item.item_name,
//                     item_description: item.item_description,
//                     price: item?.products?.selling_price || item?.price,
//                     discount: item.discount || 0,
//                     quantity: item.quantity || 1,
//                     subtotal: item.price * (item.quantity || 1),
//                     revenue_type: item.product?.revenue_type,
//                 }))
//             );
//         } catch (error) {
//             console.error('Error fetching quotation details:', error);
//         } finally {
//             setIsLoadingQuotation(false);
//         }
//     };

//     useEffect(() => {
//         if (showModal && quotationId) {
//             setIsLoadingQuotation(true);

//             fetchQuotationDetails();
//         }
//     }, [showModal, quotationId]);
//     const fetchProducts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allProducts = [];



//             const response = await axios.get(`${backendUrl}/api/products`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             const data = response.data.Data;

//             allProducts = [...allProducts, ...data]; // Append new products to the list


//             setProducts(data);
//         } catch (error) {
//             console.error('Error fetching products:', error);
//         }
//     };
//     const fetchTermsDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/quotationterm`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });

//             const termDetails = response.data.quotation_terms.data.filter(term => term.type === 'quotation');
//             if (termDetails.length > 0) {
//                 let notes = '';

//                 // Choose the appropriate content based on client currency
//                 if (clientCurrency === 'AED') {
//                     notes = termDetails[0]?.value_local || termDetails[0]?.value || '';
//                     console.log('📝 Using UAE Local Client Terms (AED)');
//                 } else if (clientCurrency === 'USD') {
//                     notes = termDetails[0]?.value_export || termDetails[0]?.value || '';
//                     console.log('📝 Using Export Client Terms (USD)');
//                 }
//                 else {
//                     notes = termDetails[0]?.value || '';
//                     console.log('📝 Using Default Terms');
//                 }

//                 // Replace currency placeholder if needed
//                 notes = notes.replace(/{{currency}}/g, clientCurrency || fetchedQuotationData?.currency);

//                 console.log('📋 Final Notes Content:', notes);

//                 setFormData((prevState) => ({
//                     ...prevState,
//                     notes: notes,
//                 }));
//             }


//             // if (termDetails.length > 0) {
//             //     let notes = termDetails[0]?.value || ''; // Assuming there's at least one term of type 'quotation'

//             //     notes = notes.replace(/{{currency}}/g, clientCurrency || fetchedQuotationData?.currency); // Replace with the client's currency


//             //     setFormData((prevState) => ({
//             //         ...prevState,
//             //         notes: notes, // Set fetched notes to formData.notes
//             //     }));
//             // }

//         } catch (error) {
//             console.error('Error fetching quotation terms:', error);
//         }
//     };

//     useEffect(() => {
//         if (showModal && quotationId && fetchedQuotationData) {
//             setFormData({
//                 ...fetchedQuotationData,
//                 notes: fetchedQuotationData.notes || formData.notes, // Ensure notes is set correctly
//             });
//         }
//     }, [showModal, quotationId, fetchedQuotationData]);

//     useEffect(() => {
//         if (showModal && !quotationId) {
//             const currentDate = new Date();
//             const formattedDate = currentDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD

//             const validTillDate = new Date();
//             validTillDate.setDate(validTillDate.getDate() + 30);
//             const formattedValidTill = validTillDate.toISOString().split('T')[0];

//             setFormData({
//                 client_id: defaultClientId || '',
//                 project_id: projectId,
//                 ref_no: '',
//                 date: formattedDate, // Set current date
//                 valid_till_date: formattedValidTill, // Set valid till date as 30 days later
//                 sale_commision_type: '',
//                 sale_commision: '',
//                 document: '',
//                 discount_amount: '',
//                 discount_type: 'amount',
//                 serial_no: '',
//                 notes: '',
//             });
//             setSelectedProducts([]);
//             setTotalAmount(0);
//             setErrors({});
//         }
//     }, [showModal, quotationId, projectId]);



//     useEffect(() => {
//         if (showModal && !productsFetched) {
//             fetchProducts();
//             setProductsFetched(true);
//         }
//     }, [showModal, productsFetched]);


//     // useEffect(() => {
//     //     console.log("🔄 useEffect Triggered in QuotationForm");
//     //     console.log("🟢 Products State:", products);
//     //     console.log("🟢 dealData:", dealData);
//     //     if (!showModal) return;
//     //     const urlParams = new URLSearchParams(window.location.search);
//     //     const isSales = urlParams.get("sales") === "true";
//     //     if (isOrder) {
//     //         console.log("✅ Using deal's products (NO API CALL)");
//     //         // setProducts(products);  
//     //         setProducts(dealData?.product_item_details.map(item => {
//     //             console.log("Product:", item);
//     //             const rawPrice = item?.price || item?.product?.selling_price; 
//     //             console.log("Raw price from item:", rawPrice);

//     //             const parsedPrice = parseFloat(rawPrice);  

//     //             if (isNaN(parsedPrice)) {
//     //                 console.error('Invalid price found:', rawPrice);  
//     //             }
//     //             return {

//     //             id: item.product_id,
//     //             product_name: item.item_name,
//     //             item_description: item.item_description,
//     //             price: item?.product?.selling_price ||item.price,
//     //             discount: item.discount_amount || 0,
//     //             quantity: 1,
//     //             subtotal: item.price * item.quantity,
//     //         };
//     //         }));
//     //         // setSelectedProducts(products);
//     //     } else if (!productsFetched) {
//     //         console.log("🚀 Fetching products from API...");
//     //         fetchProducts();
//     //         setProductsFetched(true);
//     //     }
//     // }, [showModal, isOrder,productsFetched, dealData?.product_item_details]);



//     // Reset fetch state when modal closes
//     useEffect(() => {
//         if (!showModal) {
//             setProductsFetched(false);
//         }
//     }, [showModal]);

//     const fetchLastRefNo = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             const response = await axios.get(`${backendUrl}/api/quotation/ref-no`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,

//                 params: { project_id: projectId },
//             });
//             setRefNo(response.data.ref_no);
//             setFormData(prevData => ({
//                 ...prevData,
//                 ref_no: response.data.ref_no,
//             }));
//         } catch (error) {
//             console.error('Error fetching last reference number:', error);
//         }
//     }; useEffect(() => {
//         if (showModal && !quotationId) {

//             fetchLastRefNo();
//         }
//     }, [showModal, quotationId, projectId]);
//     const usdToAedExchangeRate = 3.67;
//     // Handle form field changes
//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setFormData({
//             ...formData,
//             [name]: type === 'checkbox' ? checked : value,
//         });
//         if (errors[name]) {
//             setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
//         }
//     };

//     // Handle file upload
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setFormData(prevData => ({
//                 ...prevData,
//                 document: file,
//             }));
//         }
//     };


//     const convertPrice = (price) => {
//         console.log("🔄 Converting Price in Quotation Form:", price, "Type:", typeof price);

//         console.log("Price value being passed:", price);
//         if (price === undefined || price === null) {
//             console.error('Price is undefined or null!');
//             return '0.00';
//         }
//         const priceNumber = parseFloat(price);
//         if (isNaN(priceNumber)) {
//             console.error('Invalid price:', price);
//             return '0.00'; // Fallback value
//         }
//         if (clientCurrency === 'USD') {
//             return (priceNumber / usdToAedExchangeRate).toFixed(2);
//         }
//         return priceNumber.toFixed(2);
//     };
//     const handleEditorChange = (value) => {
//         setFormData({
//             ...formData,
//             notes: value, // Save the content from React Quill to the notes field
//         });
//     };

//     // Handle product selection
//     const handleProductSelect = (e) => {
//         const selectedProductId = e.target.value;
//         const selectedProduct = products.find(product => product.id === parseInt(selectedProductId));
//         console.log("🔄 Selected Product:", selectedProduct);
//         console.log("Raw selling price:", selectedProduct?.selling_price);
//         if (selectedProduct) {
//             // const convertedPrice = convertPrice(selectedProduct.selling_price || selectedProduct?.price);
//             const basePrice = selectedProduct.product_type === 'service'
//                 ? selectedProduct.hourly_rate // use hourly_rate for services
//                 : (selectedProduct.selling_price || selectedProduct.price);
//             const convertedPrice = convertPrice(basePrice);

//             setSelectedProducts(prevProducts => [
//                 ...prevProducts,
//                 {
//                     product_id: selectedProduct.id,
//                     item_name: selectedProduct.product_name,
//                     item_description: selectedProduct.description,
//                     price: convertedPrice,
//                     discount: selectedProduct.discount_amount || 0,
//                     quantity: 1,
//                     subtotal: convertedPrice,
//                     revenue_type: selectedProduct.revenue_type,
//                 },
//             ]);
//         }
//     };

//     // Handle quantity change
//     const handleQuantityChange = (e, productId) => {
//         const { value } = e.target;
//         if (isNaN(value) || value <= 0) return;
//         setSelectedProducts(prevProducts =>
//             prevProducts.map(product =>
//                 product.product_id === productId
//                     ? { ...product, quantity: value, subtotal: value * product.price }
//                     : product
//             )
//         );
//     };
//     // const handlePriceChange = (e, productId) => {
//     //     const { value } = e.target;
//     //     if (isNaN(value) || value < 0) return; // basic validation
//     //     setSelectedProducts(prevProducts =>
//     //         prevProducts.map(product =>
//     //             product.product_id === productId
//     //                 ? { ...product, price: parseFloat(value), subtotal: parseFloat(value) * product.quantity }
//     //                 : product
//     //         )
//     //     );
//     // };

//     // Handle product deletion

//     //    const handlePriceChange = (e, productId) => {
//     //   const { value } = e.target;
//     //   const newPrice = parseFloat(value);

//     //   // Find selected and original product
//     //   const selectedProduct = selectedProducts.find(p => p.product_id === productId);
//     //   const originalProduct = products.find(p => p.id === productId);

//     //   if (selectedProduct && originalProduct) {
//     //     const originalPrice = parseFloat(originalProduct.selling_price || originalProduct.price);

//     //     // 🟡 If user enters a value lower than original → reset & show toast
//     //     if (isNaN(newPrice) || newPrice < originalPrice) {
//     //       Swal.fire({
//     //         toast: true,
//     //         position: 'top-end',
//     //         icon: 'warning',
//     //         title: 'Invalid Price',
//     //         text: `Price cannot be lower than the ${originalPrice}. Reset to original.`,
//     //         timer: 2500,
//     //         showConfirmButton: false,
//     //         customClass: {
//     //     popup: 'custom-swal-toast'
//     //   },
//     //       target: document.querySelector('.offcanvas.show .offcanvas-body') || document.body, // 👈 attach inside Offcanvas

//     //       });

//     //       // Reset to original price
//     //       setSelectedProducts(prev =>
//     //         prev.map(p =>
//     //           p.product_id === productId
//     //             ? {
//     //                 ...p,
//     //                 price: originalPrice,
//     //                 subtotal: originalPrice * p.quantity,
//     //               }
//     //             : p
//     //         )
//     //       );
//     //       return;
//     //     }

//     //     // ✅ Otherwise, update product price normally
//     //     setSelectedProducts(prev =>
//     //       prev.map(p =>
//     //         p.product_id === productId
//     //           ? {
//     //               ...p,
//     //               price: newPrice,
//     //               subtotal: newPrice * p.quantity,
//     //             }
//     //           : p
//     //       )
//     //     );
//     //   }
//     // };

//     const handlePriceChange = (e, productId) => {
//         let newPrice = parseFloat(e.target.value);
//         const selectedProduct = selectedProducts.find(p => p.product_id === productId);
//         const originalProduct = products.find(p => p.id === productId);

//         if (selectedProduct && originalProduct) {
//             const originalPrice = clientCurrency === 'USD'
//                 ? (originalProduct.selling_price / usdToAedExchangeRate).toFixed(2)
//                 : originalProduct.selling_price;

//             if (isNaN(newPrice) || newPrice < originalPrice) {
//                 Swal.fire({
//                     toast: true,
//                     position: 'top-end',
//                     icon: 'warning',
//                     title: 'Invalid Price',
//                     text: `Price cannot be lower than ${originalPrice}`,
//                     timer: 2500,
//                     showConfirmButton: false,
//                     customClass: {
//                         popup: 'custom-swal-toast'
//                     },
//                     target: document.querySelector('.offcanvas.show .offcanvas-body') || document.body, // 👈 attach inside Offcanvas

//                 });

//                 newPrice = parseFloat(originalPrice);
//             }

//             setSelectedProducts(prev =>
//                 prev.map(p =>
//                     p.product_id === productId
//                         ? { ...p, price: newPrice, subtotal: newPrice * p.quantity }
//                         : p
//                 )
//             );
//         }
//     };



//     const handleDeleteProduct = (productId) => {
//         setSelectedProducts(prevProducts => prevProducts.filter(product => product.product_id !== productId));
//     };

//     // Calculate total amount
//     // const calculateTotalAmount = () => {
//     //     return selectedProducts.reduce((total, product) => total + parseFloat(product.subtotal || 0), 0);
//     // };

//     // // Calculate discounted total
//     // const calculateDiscountedTotal = () => {
//     //     const { discount_type, discount_amount } = formData;
//     //     const total = calculateTotalAmount();
//     //     if (discount_type === 'amount') {
//     //         return Math.max(0, total - parseFloat(discount_amount || 0));
//     //     } else if (discount_type === 'percentage') {
//     //         const discount = (parseFloat(discount_amount || 0) / 100) * total;
//     //         return Math.max(0, total - discount);
//     //     }
//     //     return total;
//     // };
//     // const calculateFinalTotal = () => {
//     //     const monthlyDiscountedTotal = calculateDiscountedTotal();
//     //     return monthlyDiscountedTotal * formData.subscription_period;
//     // };
//     // Calculate total for all products
//     // const calculateTotalAmount = () => {
//     //     return selectedProducts.reduce((total, product) => total + parseFloat(product.subtotal || 0), 0);
//     // };

//     // // Calculate total of subscription (deferred) products
//     // const calculateSubscriptionTotal = () => {
//     //     return selectedProducts.reduce((total, product) => {
//     //         if (product.revenue_type === 'deferred') {
//     //             return total + parseFloat(product.subtotal || 0);
//     //         }
//     //         return total;
//     //     }, 0);
//     // };

//     // // Calculate discount amount
//     // const calculateDiscountedTotal = () => {
//     //     const totalAmount = calculateTotalAmount();
//     //     let discount = parseFloat(formData.discount_amount || 0);

//     //     if (formData.discount_type === 'percentage') {
//     //         discount = (discount / 100) * totalAmount;
//     //     }

//     //     return discount;
//     // };

//     // // Calculate final total after discount and subscription period
//     // const calculateFinalTotal = () => {
//     //     const totalAmount = calculateTotalAmount();
//     //     const subscriptionTotal = calculateSubscriptionTotal();
//     //     const oneTimeTotal = totalAmount - subscriptionTotal;
//     //     const subscriptionPeriod = parseInt(formData.subscription_period || 1);

//     //     // Calculate discount
//     //     const discountAmount = calculateDiscountedTotal();

//     //     // Total after discount
//     //     const discountedTotal = Math.max(0, totalAmount - discountAmount);

//     //     // Split discount proportionally
//     //     const discountedSubscription = (subscriptionTotal / totalAmount) * discountedTotal;
//     //     const discountedOneTime = (oneTimeTotal / totalAmount) * discountedTotal;

//     //     // Multiply subscription products by subscription period
//     //     const finalTotal = discountedOneTime + discountedSubscription * subscriptionPeriod;

//     //     return finalTotal.toFixed(2); // final amount
//     // };

//     // Calculate total amount of all products
//     const calculateTotalAmount = () => {
//         return selectedProducts.reduce((total, product) => total + parseFloat(product.subtotal || 0), 0);
//     };

//     // Calculate total of subscription (recurring) products
//     const calculateSubscriptionTotal = () => {
//         return selectedProducts.reduce((total, product) => {
//             if (product.revenue_type === 'deferred') {
//                 return total + parseFloat(product.subtotal || 0);
//             }
//             return total;
//         }, 0);
//     };

//     // Calculate total of one-time products
//     const calculateOneTimeTotal = () => {
//         return selectedProducts.reduce((total, product) => {
//             if (product.revenue_type !== 'deferred') {
//                 return total + parseFloat(product.subtotal || 0);
//             }
//             return total;
//         }, 0);
//     };

//     // Calculate discount
//     const calculateDiscountedAmount = (baseAmount) => {
//         let discount = parseFloat(formData.discount_amount || 0);
//         if (formData.discount_type === 'percentage') {
//             discount = (discount / 100) * baseAmount;
//         }
//         return discount;
//     };

//     // Calculate final total
//     const calculateFinalTotal = () => {
//         const subscriptionTotal = calculateSubscriptionTotal();
//         const oneTimeTotal = calculateOneTimeTotal();
//         const subscriptionPeriod = parseInt(formData.subscription_period || 12);

//         // Multiply recurring part by subscription period
//         const totalBeforeDiscount = (subscriptionTotal * subscriptionPeriod) + oneTimeTotal;

//         // Apply discount
//         const discountAmount = calculateDiscountedAmount(totalBeforeDiscount);

//         const finalTotal = totalBeforeDiscount - discountAmount;
//         return finalTotal.toFixed(2);
//     };


//     // Example: How to show discount amount
//     useEffect(() => {
//         console.log('Selected Products:', selectedProducts);
//         selectedProducts.forEach(p =>
//             console.log(p.product_name, p.revenue_type, p.subtotal)
//         );
//     }, [selectedProducts]);

//     // Update total amount when products, discount, or subscription period changes
//     // useEffect(() => {
//     //     setTotalAmount(calculateFinalTotal());
//     // }, [selectedProducts, formData.discount_amount, formData.discount_type, formData.subscription_period]);

//     // Update total amount when products or discount changes
//     // useEffect(() => {
//     //     setTotalAmount(calculateDiscountedTotal());
//     // }, [selectedProducts, formData.discount_amount, formData.discount_type]);
//     // Update form data with calculated values when products or totals change
//     // useEffect(() => {
//     //   if (selectedProducts.length > 0) {
//     //     setFormData(prev => ({
//     //       ...prev,
//     //       subscription_amount: calculateSubscriptionTotal(),
//     //       deplyment_amount: calculateOneTimeTotal(),
//     //       total_amount_with_subscription: calculateSubscriptionTotal() * parseInt(prev.subscription_period || 1),
//     //       amount: calculateFinalTotal()
//     //     }));
//     //   }
//     // }, [selectedProducts, formData.discount_amount, formData.discount_type, formData.subscription_period]);
//     useEffect(() => {
//         if (selectedProducts.length > 0) {
//             const subscriptionPeriod = parseInt(formData.subscription_period) || 12;
//             const subscriptionTotal = calculateSubscriptionTotal();
//             const oneTimeTotal = calculateOneTimeTotal();

//             setFormData(prev => ({
//                 ...prev,
//                 subscription_amount: subscriptionTotal,
//                 deplyment_amount: oneTimeTotal,
//                 total_amount_with_subscription: subscriptionTotal * subscriptionPeriod,
//                 amount: calculateFinalTotal()
//             }));
//         }
//     }, [formData.subscription_period, selectedProducts, formData.discount_amount, formData.discount_type]);
//     // Debug effect
//     useEffect(() => {
//         console.log('🔄 Products changed - Recalculating totals:');
//         console.log('Selected Products:', selectedProducts);
//         console.log('Subscription Total:', calculateSubscriptionTotal());
//         console.log('One-Time Total:', calculateOneTimeTotal());
//         console.log('Final Total:', calculateFinalTotal());
//     }, [selectedProducts]);

//     // Validate form
//     const validateForm = () => {
//         const newErrors = {};
//         if (selectedProducts.length === 0) {
//             newErrors.products = 'At least one product is required';
//         }
//         return newErrors;
//     };

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         const validationErrors = validateForm();
//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             setLoading(false);
//             return;
//         }

//         try {
//             const updatedProducts = selectedProducts.map(product => ({
//                 product_id: product.product_id || '',
//                 item_name: product.item_name || '',
//                 item_description: product.item_description || '',
//                 price: product.price,
//                 quantity: product.quantity,
//                 discount: product.discount,
//                 subtotal: product.subtotal,
//             }));
//             const subscriptionPeriod = parseInt(formData.subscription_period) || 12;
//             const subscriptionTotal = calculateSubscriptionTotal();
//             const updatedFormData = {
//                 ...formData,
//                 amount: calculateFinalTotal(),
//                 products: updatedProducts,
//                 subscription_period: subscriptionPeriod,
//                 total_amount_with_subscription: subscriptionTotal * subscriptionPeriod,
//                 subscription_amount: calculateSubscriptionTotal(),
//                 deplyment_amount: calculateOneTimeTotal(),

//             };
//             let apierrors;
//             if (quotationId) {
//                 apierrors = await editQuotation(quotationId, updatedFormData);
//             } else {
//                 apierrors = await addQuotation(updatedFormData);
//             }
//             if (apierrors && Object.keys(apierrors).length > 0) {
//                 setErrors(apierrors);
//             } else {
//                 setErrors({});
//                 handleClose();
//             }
//         } catch (error) {
//             console.error("An error occurred:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ width: '850px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>{quotationId ? 'Edit Quotation' : 'Create Quotation'}</Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} />

//             <Offcanvas.Body>
//                 <Form >
//                     <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group controlId="name">
//                                 <Form.Label style={{ fontSize: "13px" }}>Client</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     // name="client_id"
//                                     value={clientName}
//                                     // onChange={handleChange}
//                                     readOnly />

//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="project">
//                                 <Form.Label style={{ fontSize: "13px" }}>Project</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     // name="project_id"
//                                     value={projectName}
//                                     // onChange={handleChange}
//                                     readOnly
//                                 />

//                             </Form.Group>
//                         </Col>

//                     </Row>


//                     <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group controlId="ref_no">
//                                 <Form.Label style={{ fontSize: "13px" }}>Reference Number</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="ref_no"
//                                     value={formData.ref_no}
//                                 // onChange={handleChange}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                             <Form.Group controlId="date">
//                                 <Form.Label style={{ fontSize: "13px" }}>Date</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="date"
//                                     name="date"
//                                     value={formData.date}
//                                     onChange={handleChange}
//                                     required
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>
//                     <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group controlId="brand">
//                                 <Form.Label style={{ fontSize: "13px" }}>Brand</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', borderRadius: '14px', height: '35px' }}
//                                     name="brand_id"
//                                     value={formData.brand_id}
//                                     onChange={handleChange}
//                                 >
//                                     <option value="">Select Brand</option>
//                                     {brands.map(brand => (
//                                         <option key={brand.id} value={brand.id}>{brand.name}</option>
//                                     ))}
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>
//                          <Col md={6}>
//                             <Form.Group controlId="brand">
//                                 <Form.Label style={{ fontSize: "13px" }}>License Type</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', borderRadius: '14px', height: '35px' }}
//                                     name="license_type_id"
//                                     value={formData.license_type_id}
//                                     onChange={handleChange}
//                                 >
//                                     <option value="">Select License Type</option>
//                                     {categories.allCategoriesList.map(category => (
//                                         <option key={category.id} value={category.id}>{category.name}</option>
//                                     ))}

//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>


//                     </Row>
//                     {/* <Row className="mb-3">
//                         <Col md={6}>
//                             <Form.Group controlId="valid_till_date">
//                                 <Form.Label style={{ fontSize: "13px" }}>Valid Till Date</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="date"
//                                     name="valid_till_date"
//                                     value={formData.valid_till_date}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>
//                         </Col>
//                        <Col md={6}>
//                             <Form.Group controlId="discount_amount">
//                                 <Form.Label style={{ fontSize: "13px" }}> One Time Discount</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="text"
//                                     name="discount_amount"
//                                     value={formData.discount_amount}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row> */}
//                     <Row className="mb-3">

//                         {/* <Col md={6}>
//                             <Form.Group controlId="type">
//                                 <Form.Label style={{ fontSize: "13px" }}>Discount Type</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     name="discount_type"
//                                     value={formData.discount_type}
//                                     onChange={handleChange}
//                                 >
//                                     <option value="amount">Amount</option>
//                                     <option value="percentage">Percentage</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col> */}
//                         <Col md={6}>
//                             <Form.Group controlId="deployment">
//                                 <Form.Label style={{ fontSize: "13px" }}>Deployment Type</Form.Label>
//                                 <Form.Select
//                                     name="deployment"
//                                     value={formData.deployment}
//                                     onChange={handleChange}
//                                     style={{ fontSize: '13px', borderRadius: '14px', height: '35px' }}
//                                 >
//                                     <option value="">Select Deployment</option>
//                                     <option value="cloud">Cloud</option>
//                                     <option value="on-premise">On Premise</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>

//                         <Col md={6}>
//                             <Form.Group controlId="deployment">
//                                 <Form.Label style={{ fontSize: "13px" }}>Model</Form.Label>
//                                 <Form.Select
//                                     name="deployment"
//                                     value={formData.deployment}
//                                     onChange={handleChange}
//                                     style={{ fontSize: '13px', borderRadius: '14px', height: '35px' }}
//                                 >
//                                     <option value="">Select</option>
//                                     <option value="new">New</option>
//                                     <option value="expand">Expand</option>
//                                 </Form.Select>
//                             </Form.Group>
//                         </Col>

//                     </Row>
//                     <Row className="mb-3">
//                          <Col md={6}>
//                             <Form.Group controlId="subscription_period">
//                                 <Form.Label style={{ fontSize: "13px" }}>Subscription Period (Months)</Form.Label>
//                                 <Form.Control
//                                     style={{ fontSize: '13px', maxWidth: '370px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
//                                     type="number"
//                                     name="subscription_period"
//                                     value={formData.subscription_period || 12}
//                                     onChange={(e) => {
//                                         const period = parseInt(e.target.value) || 12;
//                                         setFormData(prev => ({
//                                             ...prev,
//                                             subscription_period: period
//                                         }));
//                                     }}
//                                     min="1"
//                                 />
//                             </Form.Group>
//                         </Col>
//                         </Row>

//                     <br />

//                     {/* <Row className="mb-3">
//                         <Col md={12}>
//                             <Form.Group controlId="type">
//                                 <Form.Label style={{ fontSize: "13px" }}>Select Product</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: '13px' }}
//                                     onChange={handleProductSelect}
//                                     className={`form-control ${errors?.products ? 'is-invalid' : ''}`}

//                                 >
//                                     <option value="">Select Product</option>
//                                     {Array.isArray(products) && products.length > 0 ? (
//                                         products.map(product => (
//                                             <option key={product.id} value={product.id}>
//                                                 {product.product_name}
//                                             </option>
//                                         ))
//                                     ) : (
//                                         <option disabled>No products available</option>
//                                     )}
//                                 </Form.Select>
//                                 {errors.products && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.products}</div>}

//                             </Form.Group>
//                         </Col>
//                     </Row><br /> */}

//                     {/* <div>
//                         <table className="table font-size-13">
//                             <thead>
//                                 <tr>
//                                     <th width="20%" scope="col">Product</th>
//                                     <th width="30%" scope="col">Description</th>
//                                     <th width="10%" scope="col">Rate</th>
//                                     <th width="10%" scope="col">Qty</th>
//                                     <th width="10%" scope="col">SubTotal</th>
//                                     <th width="10%" scope="col">Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {selectedProducts.map(product => (
//                                     <tr key={product.id}>
//                                         <td>{product.item_name}</td>
//                                         <td>{product.item_description}</td>
//                                         <td>
//                                             <input
//                                                 type="number"
//                                                 value={product.price}
//                                                 min="0"
//                                                 className="form-control"
//                                                 onChange={(e) => handlePriceChange(e, product.product_id)}
//                                                 style={{ width: '80px' }}
//                                             />
//                                         </td>

//                                         <td>
//                                             <input
//                                                 type="number"
//                                                 value={product.quantity}
//                                                 min="1"
//                                                 className='form-control'
//                                                 onChange={(e) => handleQuantityChange(e, product.product_id)}
//                                             />
//                                         </td>
//                                         <td>{product.subtotal}</td>
//                                         <td>
//                                             <span
//                                                 style={{ cursor: 'pointer', color: 'grey' }}
//                                                 onClick={() => handleDeleteProduct(product.product_id)}
//                                             >
//                                                 <i className="fa fa-trash"></i>
//                                             </span>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div> */}
//                     <br /><br />

//                     {/* {formData.discount_amount > 0 && (
//                         <Row className="mb-3">
//                             <Col md={9}></Col>
//                             <Col md={3}>
//                                 <label className="font_13 theme_text f_w_500 mb-0" htmlFor="discountAmount">
//                                     Discount ({formData.discount_type === 'percentage' ? `${formData.discount_amount}%` : ''})
//                                 </label>
//                                 <div className="primary_input grid_input calculated_total text-end">
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={((formData.discount_type === 'percentage')
//                                             ? ((totalAmount * parseFloat(formData.discount_amount || 0)) / 100)
//                                             : parseFloat(formData.discount_amount || 0)).toFixed(2)} // Calculate Discount
//                                         name="discount_amount"
//                                         readOnly
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                     )}

//                     <Row className="mb-3">

//                         <Col md={9}></Col>

//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0" htmlFor="totalAmount">Total Amount</label>

//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     // value={totalAmount.toFixed(2)}
//                                     value={calculateTotalAmount().toFixed(2)}
//                                     name="amount"
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row>
//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0" htmlFor="totalAmount">
//                                 Total Amount ({subscriptionPeriod} months)
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     value={totalAmount.toFixed(2)}
//                                     name="amount"
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row> */}
//                     {/* Monthly Breakdown Section */}
//                     {/* <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0">
//                                 Total License Cost Per Month
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     name='subscription_amount'
//                                     className="form-control font-size-13"
//                                     // value={calculateTotalAmount().toFixed(2)}
//                                     value={calculateSubscriptionTotal().toFixed(2)}
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row> */}

//                     {/* {formData.discount_amount > 0 && (
//                         <>
//                             <Row className="mb-3">
//                                 <Col md={9}></Col>
//                                 <Col md={3}>
//                                     <label className="font_13 theme_text f_w_500 mb-0 font-size-13" htmlFor="discountAmount">
//                                         Discount ({formData.discount_type === 'percentage' ? `${formData.discount_amount}%` : ''})
//                                     </label>
//                                     <div className="primary_input grid_input calculated_total text-end">
//                                         <input
//                                             type="text"
//                                             className="form-control font-size-13"
//                                             value={(
//                                                 (formData.discount_type === 'percentage')
//                                                     ? ((calculateTotalAmount() * parseFloat(formData.discount_amount || 0)) / 100)
//                                                     : parseFloat(formData.discount_amount || 0)
//                                             ).toFixed(2)}
//                                             readOnly
//                                         />
//                                     </div>
//                                 </Col>
//                             </Row> */}
//                     {/* <Row className="mb-3">
//                                 <Col md={9}></Col>
//                                 <Col md={3}>
//                                     <label className="font-size-13 theme_text f_w_500 mb-0">
//                                         Monthly Total After Discount
//                                     </label>
//                                     <div className="primary_input grid_input calculated_total text-end">
//                                         <input
//                                             type="text"
//                                             className="form-control font-size-13"
//                                             // value={calculateDiscountedTotal().toFixed(2)}
//                                             value={(calculateFinalTotal() / parseInt(formData.subscription_period)).toFixed(2)}
//                                             readOnly
//                                         />
//                                     </div>
//                                 </Col>
//                             </Row> */}
//                     {/* </> */}
//                     {/* )} */}

//                     {/* Monthly Total After Discount */}


//                     {/* Subscription Period Multiplier */}
//                     {/* <Row className="mb-3">
//     <Col md={9}></Col>
//     <Col md={3}>
//         <label className="font-size-13 theme_text f_w_500 mb-0">
//             × {subscriptionPeriod} Months
//         </label>
//     </Col>
// </Row> */}

//                     {/* Final Total Amount */}
//                     {/* <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0" htmlFor="totalAmount">
//                                 Total Cost Per {formData.subscription_period} months
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     // value={totalAmount}
//                                     value={(calculateSubscriptionTotal() * parseInt(formData.subscription_period || 1)).toFixed(2)}

//                                     // value={calculateFinalTotal()}
//                                     name="total_amount_with_subscription"
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row>
//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0">
//                                 Setup / Deployment Cost
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     // value={calculateTotalAmount().toFixed(2)}
//                                     value={calculateOneTimeTotal().toFixed(2)}
//                                     name="deplyment_amount"                                readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row>
//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0">
//                                 Grand Total
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     // value={calculateTotalAmount().toFixed(2)}
//                                     value={calculateFinalTotal()}
//                                     readOnly
//                                     name='amount'
//                                 />
//                             </div>
//                         </Col>
//                     </Row> */}

//                     {/* Total License Cost Per Month - ALWAYS CALCULATE */}
//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0">
//                                 Total License Cost Per Month
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     name='subscription_amount'
//                                     className="form-control font-size-13"
//                                     value={calculateSubscriptionTotal().toFixed(2)}
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row>

//                     {/* Discount Display - ALWAYS CALCULATE */}
//                     {formData.discount_amount > 0 && (
//                         <Row className="mb-3">
//                             <Col md={9}></Col>
//                             <Col md={3}>
//                                 <label className="font_13 theme_text f_w_500 mb-0 font-size-13">
//                                     Discount ({formData.discount_type === 'percentage' ? `${formData.discount_amount}%` : ''})
//                                 </label>
//                                 <div className="primary_input grid_input calculated_total text-end">
//                                     <input
//                                         type="text"
//                                         className="form-control font-size-13"
//                                         value={calculateDiscountedAmount(calculateTotalAmount()).toFixed(2)}
//                                         readOnly
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                     )}

//                     {/* Total Cost for Subscription Period - ALWAYS CALCULATE */}
//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0">
//                                 Total Cost Per {formData.subscription_period} months
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     value={(
//                                         (calculateSubscriptionTotal() * parseInt(formData.subscription_period || 12)) -
//                                         calculateDiscountedAmount(calculateSubscriptionTotal() * parseInt(formData.subscription_period || 12))
//                                     ).toFixed(2)}
//                                     name="total_amount_with_subscription"
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row>

//                     {/* Setup/Deployment Cost - ALWAYS CALCULATE */}
//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0">
//                                 Setup / Deployment Cost
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     value={(
//                                         calculateOneTimeTotal() -
//                                         calculateDiscountedAmount(calculateOneTimeTotal())
//                                     ).toFixed(2)}
//                                     name="deplyment_amount"
//                                     readOnly
//                                 />
//                             </div>
//                         </Col>
//                     </Row>

//                     {/* Grand Total - ALWAYS CALCULATE */}
//                     <Row className="mb-3">
//                         <Col md={9}></Col>
//                         <Col md={3}>
//                             <label className="font-size-13 theme_text f_w_500 mb-0">
//                                 Grand Total
//                             </label>
//                             <div className="primary_input grid_input calculated_total text-end">
//                                 <input
//                                     type="text"
//                                     className="form-control font-size-13"
//                                     value={calculateFinalTotal()}
//                                     readOnly
//                                     name='amount'
//                                 />
//                             </div>
//                         </Col>
//                     </Row>

//                     <br /><br />

//                     <Row className="mb-3">
//                         <Col md={12}>
//                             <Form.Group controlId="notes">
//                                 <Form.Label style={{ fontSize: "13px" }}>Payment Terms</Form.Label>
//                                 <ReactQuill
//                                     value={formData.notes}
//                                     onChange={handleEditorChange} // Bind the editor value to the notes field
//                                     theme="snow"
//                                 // style={{ height: '100px' }}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                 </Form>
//             </Offcanvas.Body>
//             <div className="p-3 d-flex justify-content-end border-top">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Close
//                 </button>
//                 <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
//                     {loading && <Spinner animation="border" size="sm" style={{ marginRight: '10px' }} />}
//                     Save
//                 </button>
//             </div>
//         </Offcanvas>
//     );
// };

// export default QuotationForm;


import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Spinner, Offcanvas, Button, Card, Table } from 'react-bootstrap';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Swal from "sweetalert2";
import QuotationPreviewModal from './QuotationPreviewModal';
import Select from 'react-select';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const QuotationForm = ({
    showModal,
    handleClose,
    products = [], setProducts,
    quotationId,
    projectId,
    quotationData,
    addQuotation,
    defaultClientId,
    editQuotation, projectName, clientName, clientCurrency, isOrder, dealData, isAllQuotationsPage = false, projects = [], // Pass projects data
    clients = [], getClientCurrency,
}) => {
    console.log('client,project', clientCurrency, clientName, projectName);

    // Step management
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [amcList, setAmcList] = useState([]);
    const [selectedClientCurrency, setSelectedClientCurrency] = useState(clientCurrency || 'AED');



    // Form data states
    const [formData, setFormData] = useState({
        client_id: defaultClientId || '',
        project_id: projectId,
        ref_no: '',
        date: '',
        valid_till_date: '',
        brand_ids: [],
        license_type_id: '',
        deployment: '',
        model_type: '',
        subscription_period: 12,
        discount_amount: '',
        discount_type: 'amount',
        notes: '',
        amount: 0,
        subscription_amount: 0,
        deplyment_amount: 0,
        total_amount_with_subscription: 0,
        service_amount: 0,
        transaction_type: dealData?.transaction_type || '', // Set from deal data if available
        partner_id: dealData?.partner_id || '',
        partner_tier_id: dealData?.partner_tier_id || '',
        margin_percentage: dealData?.margin_percentage || ''
    });

    const [organisations, setOrganisations] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [refNo, setRefNo] = useState('');
    const [errors, setErrors] = useState({});
    const [editableDeploymentAmount, setEditableDeploymentAmount] = useState(0);
    const [editableDeploymentDescriptions, setEditableDeploymentDescriptions] = useState({});
    const [editableServiceDescriptions, setEditableServiceDescriptions] = useState({});
    const [partnerOverrides, setPartnerOverrides] = useState([]);



    // ✅ New fields for Custom Integration
    const [customIntegrationDescription, setCustomIntegrationDescription] = useState("");
    const [customIntegrationTotal, setCustomIntegrationTotal] = useState(0);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    const origin = localStorage.getItem('user-origin');
    const token = userInfo?.token;
    const usdToAedExchangeRate = 3.67;
    const [localProducts, setLocalProducts] = useState(products || []);

    // Update the main useEffect
    // useEffect(() => {
    //     if (showModal) {
    //         fetchBrands();
    //         fetchCategories();
    //         fetchProducts();
    //         fetchAMC();

    //         if (quotationId) {
    //             // Edit mode - fetch quotation details
    //             fetchQuotationDetails();
    //         } else {
    //             // Create mode - set defaults
    //             fetchLastRefNo();
    //             fetchTermsDetails();

    //             // Reset form for new quotation
    //             const currentDate = new Date().toISOString().split('T')[0];
    //             const validTillDate = new Date();
    //             validTillDate.setDate(validTillDate.getDate() + 30);
    //             const formattedValidTill = validTillDate.toISOString().split('T')[0];

    //             setFormData(prev => ({
    //                 ...prev,
    //                 date: currentDate,
    //                 valid_till_date: formattedValidTill,
    //                 brand_id: '',
    //                 license_type_id: '',
    //                 deployment_type: '',
    //                 model_type: '',
    //                 subscription_period: 12,
    //                 discount_amount: '',
    //                 discount_type: 'amount'
    //             }));
    //             setSelectedProducts([]);
    //             setCustomIntegrationDescription("");
    //             setCustomIntegrationTotal(0);
    //         }
    //     }
    // }, [showModal, quotationId]);

    const fetchOrganisations = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: { type: 'org,client' },
                skipLoader: true,
            });
            setOrganisations(response.data.data?.data || response.data.data || []);
        } catch (error) {
            console.error('Error fetching organisations:', error);
        }
    };

    useEffect(() => {
        if (showModal) {
            fetchBrands();
            fetchCategories();
            fetchProducts();
            fetchAMC();
            fetchOrganisations();

            if (quotationId) {
                fetchQuotationDetails();
            } else {
                fetchLastRefNo();
                fetchTermsDetails();

                const currentDate = new Date().toISOString().split('T')[0];
                const validTillDate = new Date();
                validTillDate.setDate(validTillDate.getDate() + 30);
                const formattedValidTill = validTillDate.toISOString().split('T')[0];

                setFormData(prev => ({
                    ...prev,
                    date: currentDate,
                    valid_till_date: formattedValidTill,
                    brand_ids: [],
                    license_type_id: '',
                    deployment_type: '',
                    model_type: '',
                    subscription_period: 12,
                    discount_amount: '',
                    discount_type: 'amount',
                    // Sync from dealData if creating new
                    transaction_type: dealData?.transaction_type || prev.transaction_type || '',
                    partner_id: dealData?.partner_id || prev.partner_id || '',
                    partner_tier_id: dealData?.partner_tier_id || prev.partner_tier_id || '',
                    margin_percentage: dealData?.margin_percentage || prev.margin_percentage || ''
                }));
                setSelectedProducts([]);
                setCustomIntegrationDescription("");
                setCustomIntegrationTotal(0);
            }
        }
    }, [showModal, quotationId, projectId, defaultClientId, clientCurrency, dealData]);

    const fetchPartnerOverrides = async (partnerId) => {
        setPartnerOverrides([]);
        if (!partnerId) {
            return;
        }
        try {
            const response = await axios.get(`${backendUrl}/api/partner-product-pricing`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: { partner_id: partnerId },
                skipLoader: true,
            });
            setPartnerOverrides(response.data.data || []);
        } catch (error) {
            console.error('Error fetching partner overrides:', error);
        }
    };

    useEffect(() => {
        console.log('🚀 [QuotationForm] Mounting and checking pricing context...');
    }, []);

    // 1. Unified effect to handle partner overrides FETCHING
    useEffect(() => {
        const clientNameRaw = formData.client_name || dealData?.organisation?.name || dealData?.client_name || quotationData?.client_name || dealData?.organisation_name;
        const currentClientName = (clientNameRaw || '').trim();
        
        // Find if this client entity exists as a "Partner" in the organizations list for pricing purposes
        // Priority Match: Find record with matching name that identifies as a 'CLIENT' first
        const clientMatch = organisations?.find(org => 
            (org.name || org.organisation_name || '').trim().toLowerCase() === currentClientName.toLowerCase() && 
            org.contact_type?.toLowerCase() === 'client'
        );

        const partnerMatch = organisations?.find(org => 
            (org.name || org.organisation_name || '').trim().toLowerCase() === currentClientName.toLowerCase() && 
            org.org_type?.toLowerCase() === 'partner'
        );

        const pricingPartnerOrg = clientMatch || partnerMatch;
        const isClientPartnerResult = !!pricingPartnerOrg;

        const resolvedTransactionType = formData.transaction_type || dealData?.transaction_type || quotationData?.transaction_type || 'direct';
        const effectiveTransactionType = isClientPartnerResult ? 'partner' : resolvedTransactionType;

        const resolvedClientId = formData.client_id || dealData?.organisation_id || dealData?.client_id || quotationData?.organisation_id || quotationData?.client_id;
        const resolvedPartnerId = formData.partner_id || dealData?.partner_id || quotationData?.partner_id;

        const partnerIdForPricing = (effectiveTransactionType.toLowerCase() === 'partner' || !!resolvedPartnerId)
            ? (pricingPartnerOrg?.id || resolvedClientId)
            : null;

        if (partnerIdForPricing) {
            console.log('📡 [Pricing] MATCH SUCCESS:', {
                searchingName: currentClientName,
                matchedId: pricingPartnerOrg?.id,
                matchedType: pricingPartnerOrg?.contact_type || pricingPartnerOrg?.org_type,
                idPassedToApi: partnerIdForPricing
            });
            fetchPartnerOverrides(partnerIdForPricing);
        } else {
            console.log('📡 [Pricing] MATCH FAILED for:', currentClientName, ' Transaction:', effectiveTransactionType, ' (Resolved ID was:', resolvedClientId, ')');
            setPartnerOverrides([]);
        }
    }, [formData.partner_id, formData.client_id, formData.transaction_type, formData.client_name, dealData?.partner_id, dealData?.organisation_id, dealData?.client_id, dealData?.transaction_type, dealData?.organisation?.name, dealData?.organisation_name, organisations, quotationData?.transaction_type, quotationData?.organisation_id, quotationData?.client_id]);

    // 2. Unified effect to Sync LocalProducts whenever products OR overrides change
    useEffect(() => {
        if (!Array.isArray(products) || products.length === 0) return;

        console.log('🔄 [LocalProducts] Syncing products with overrides. Count:', products.length, 'Overrides:', partnerOverrides.length);

        const clientNameRaw = formData.client_name || dealData?.organisation?.name || dealData?.client_name || quotationData?.client_name || dealData?.organisation_name;
        const currentClientName = (clientNameRaw || '').trim();
        const clientMatch = organisations?.find(org => 
            (org.name || org.organisation_name || '').trim().toLowerCase() === currentClientName.toLowerCase() && 
            org.contact_type?.toLowerCase() === 'client'
        );
        const partnerMatch = organisations?.find(org => 
            (org.name || org.organisation_name || '').trim().toLowerCase() === currentClientName.toLowerCase() && 
            org.org_type?.toLowerCase() === 'partner'
        );
        const pricingPartnerOrg = clientMatch || partnerMatch;
        const isClientPartnerResult = !!pricingPartnerOrg;
        const resolvedTransactionType = formData.transaction_type || dealData?.transaction_type || quotationData?.transaction_type || 'direct';
        const effectiveTransactionType = isClientPartnerResult ? 'partner' : resolvedTransactionType;

        const updatedLocalProducts = products.map(product => {
            if (!product.pricings || !Array.isArray(product.pricings)) return product;

            const updatedPricings = product.pricings.map(pricing => {
                const override = (partnerOverrides || []).find(ov => String(ov.product_pricing_id) === String(pricing.id));
                let newPricing = { ...pricing };

                if (override) {
                    newPricing.partner_price = override.partner_price != null ? override.partner_price : null;
                    newPricing.end_customer_price = override.end_customer_price != null ? override.end_customer_price : null;
                    newPricing.deployment_cost = override.partner_deployment_price != null ? override.partner_deployment_price : pricing.deployment_cost;
                } else {
                    newPricing.partner_price = null;
                    newPricing.end_customer_price = null;
                }

                // Update 'price' field for UI consistency
                const partnerPrice = (newPricing.partner_price != null && Number(newPricing.partner_price) > 0) ? Number(newPricing.partner_price) : 0;
                const endCustomerPrice = (newPricing.end_customer_price != null && Number(newPricing.end_customer_price) > 0) ? Number(newPricing.end_customer_price) : 0;
                const standardPrice = Number(pricing.price || pricing.amount || 0);

                let effectivePrice = standardPrice;
                if (effectiveTransactionType.toLowerCase() === 'partner' && partnerPrice > 0) {
                    effectivePrice = partnerPrice;
                } else if (effectiveTransactionType.toLowerCase() === 'margin_based' && endCustomerPrice > 0) {
                    effectivePrice = endCustomerPrice;
                }

                if (Number(newPricing.price) !== Number(effectivePrice)) {
                    newPricing.price = effectivePrice;
                }

                return newPricing;
            });

            return { ...product, pricings: updatedPricings };
        });

        setLocalProducts(updatedLocalProducts);
    }, [products, partnerOverrides, formData.transaction_type, dealData?.transaction_type, quotationData?.transaction_type, formData.client_name, dealData?.organisation?.name, organisations]);

    useEffect(() => {
        // When transaction_type or partnerOverrides changes, RE-CALCULATE price for already selected products
        if (selectedProducts.length > 0) {
            const updatedProducts = selectedProducts.map(sp => {
                const product = sp._product_raw;
                if (!product) return sp;

                const selectedLicenseId = formData.license_type_id;
                const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
                const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

                let matchedPricing = null;
                if (Array.isArray(product.pricings) && selectedLicenseName) {
                    matchedPricing = product.pricings.find(p =>
                        String(p.license_model).toLowerCase() === selectedLicenseName
                    );
                }
                if (!matchedPricing && Array.isArray(product.pricings) && product.pricings.length > 0) {
                    matchedPricing = product.pricings[0];
                }

                const clientOrg = organisations?.find(org => String(org.id) === String(formData.client_id || dealData?.client_id));
                const isClientPartner = clientOrg?.org_type?.toLowerCase() === 'partner' || 
                                        (dealData?.partner_name && dealData?.organisation?.name && dealData.partner_name === dealData.organisation.name && clientOrg?.contact_type?.toLowerCase() === 'client');

                const resolvedClientId = formData.client_id || dealData?.client_id || quotationData?.client_id;
                const resolvedPartnerId = formData.partner_id || dealData?.partner_id || quotationData?.partner_id;

                let clientNameForLookup = clientOrg?.name || dealData?.organisation?.name || dealData?.client_name;
                const pricingPartnerOrg = organisations?.find(org => 
                    org.name && clientNameForLookup && 
                    org.name.toLowerCase() === clientNameForLookup.toLowerCase() && 
                    (org.org_type?.toLowerCase() === 'partner' || org.contact_type?.toLowerCase() === 'client')
                );

                let transactionType = formData.transaction_type || dealData?.transaction_type || quotationData?.transaction_type || 'direct';
                if (isClientPartner) {
                    transactionType = 'partner';
                }
                
                // Effective partner context check
                const isPartnerContext = transactionType.toLowerCase() === 'partner' || !!resolvedPartnerId;
                const finalPartnerIdForPricing = isPartnerContext ? (pricingPartnerOrg?.id || resolvedClientId) : null;
                
                let effectiveBasePriceRaw = null;
                let effectiveDeploymentRaw = null;
                let finalMatchedPricing = matchedPricing ? { ...matchedPricing } : null;

                if (finalMatchedPricing) {
                    const standardPrice = Number(finalMatchedPricing.price || 0);
                    const override = partnerOverrides.find(ov => String(ov.product_pricing_id) === String(finalMatchedPricing.id));
                    
                    // ✅ ONLY use overrides for partner-specific pricing (Old concept of using pricing.partner_price is removed)
                    if (override) {
                        if (override.partner_price != null) finalMatchedPricing.partner_price = override.partner_price;
                        if (override.end_customer_price != null) finalMatchedPricing.end_customer_price = override.end_customer_price;
                        if (override.partner_deployment_price != null) finalMatchedPricing.deployment_cost = override.partner_deployment_price;
                    } else {
                        finalMatchedPricing.partner_price = null;
                        finalMatchedPricing.end_customer_price = null;
                    }

                    const partnerPriceRaw = finalMatchedPricing.partner_price;
                    const endCustomerPriceRaw = finalMatchedPricing.end_customer_price;
                    const partnerDeploymentRaw = finalMatchedPricing.deployment_cost;

                    const partnerPrice = (partnerPriceRaw !== null && partnerPriceRaw !== undefined && Number(partnerPriceRaw) > 0)
                        ? Number(partnerPriceRaw) : 0;
                    const endCustomerPrice = (endCustomerPriceRaw !== null && endCustomerPriceRaw !== undefined && Number(endCustomerPriceRaw) > 0)
                        ? Number(endCustomerPriceRaw) : 0;
                    
                    effectiveDeploymentRaw = (partnerDeploymentRaw !== null && partnerDeploymentRaw !== undefined)
                        ? Number(partnerDeploymentRaw) : Number(finalMatchedPricing.deployment_cost || 0);

                    switch (transactionType.toLowerCase()) {
                        case 'partner':
                            effectiveBasePriceRaw = partnerPrice > 0 ? partnerPrice : standardPrice;
                            break;
                        case 'margin_based':
                            effectiveBasePriceRaw = endCustomerPrice > 0 ? endCustomerPrice : standardPrice;
                            break;
                        default:
                            effectiveBasePriceRaw = standardPrice;
                    }
                }

                const productCurrency = getProductCurrency(product);
                const finalPriceRaw = effectiveBasePriceRaw !== null ? effectiveBasePriceRaw : (sp.price || 0);
                const convertedPrice = convertPrice(finalPriceRaw, productCurrency);
                
                const finalDeploymentRaw = effectiveDeploymentRaw !== null ? effectiveDeploymentRaw : (sp.deployment_cost || 0);
                const convertedDeployment = convertPrice(finalDeploymentRaw, productCurrency);

                // ✅ Update ALL pricings in the array with overrides to keep the list accurate
                const updatedPricings = (product.pricings || []).map(pricing => {
                    const override = partnerOverrides.find(ov => String(ov.product_pricing_id) === String(pricing.id));
                    if (override) {
                        return {
                            ...pricing,
                            partner_price: override.partner_price != null ? override.partner_price : pricing.partner_price,
                            end_customer_price: override.end_customer_price != null ? override.end_customer_price : pricing.end_customer_price,
                            deployment_cost: override.partner_deployment_price != null ? override.partner_deployment_price : pricing.deployment_cost
                        };
                    }
                    return pricing;
                });

                // Find the matched pricing in the updated array
                const updatedMatchedPricing = updatedPricings.find(p => String(p.id) === String(finalMatchedPricing?.id)) || finalMatchedPricing;

                return {
                    ...sp,
                    price: Number(convertedPrice),
                    deployment_cost: Number(convertedDeployment),
                    subtotal: Number((Number(convertedPrice) * (sp.quantity || 1) * (sp.agents || 1)).toFixed(2)),
                    selected_pricing: updatedMatchedPricing,
                    pricings: updatedPricings,
                    _debug: { ...sp._debug, recalculated_at: new Date().toISOString() }
                };
            });

            // Prevent infinite loop by checking if values actually changed
            const isDifferent = JSON.stringify(updatedProducts.map(p => ({ p: p.price, d: p.deployment_cost, pr: p.pricings?.[0]?.partner_price }))) !== 
                               JSON.stringify(selectedProducts.map(p => ({ p: p.price, d: p.deployment_cost, pr: p.pricings?.[0]?.partner_price })));
            if (isDifferent) {
                setSelectedProducts(updatedProducts);
            }
        }
    }, [formData.transaction_type, partnerOverrides, formData.license_type_id, dealData?.transaction_type, quotationData?.transaction_type]);
    // Determine which currency to use throughout the component
    const getCurrentCurrency = () => {
        // For AllQuotations page, use the selected client's currency
        if (isAllQuotationsPage) {
            return selectedClientCurrency;
        }
        // For other parent components, use the passed clientCurrency prop
        return clientCurrency || 'AED';
    };

    const currentCurrency = getCurrentCurrency();

    // Update currency when client changes (for AllQuotations page)
    useEffect(() => {
        if (isAllQuotationsPage && formData.client_id && getClientCurrency) {
            const currency = getClientCurrency(parseInt(formData.client_id));
            setSelectedClientCurrency(currency);
        }
    }, [formData.client_id, isAllQuotationsPage, getClientCurrency]);

    // Also update when the clientCurrency prop changes (for other parents)
    useEffect(() => {
        if (!isAllQuotationsPage && clientCurrency) {
            setSelectedClientCurrency(clientCurrency);
        }
    }, [clientCurrency, isAllQuotationsPage]);

    const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);
    const [fetchedQuotationData, setFetchedQuotationData] = useState(null);

    const fetchQuotationDetails = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const quotation = response.data.quotation;

            setFetchedQuotationData(quotation);
            setFormData({
                client_id: quotation.client_id,
                project_id: quotation.project_id,
                ref_no: quotation.ref_no || '',
                date: quotation.date || '',
                valid_till_date: quotation.valid_till_date || '',
                sale_commision_type: quotation.sale_commision_type || '',
                sale_commision: quotation.sale_commision || '',
                document: quotation.document || '',
                discount_amount: quotation.discount_amount || '',
                discount_type: quotation.discount_type || 'amount',
                serial_no: quotation.serial_no || '',
                notes: quotation.notes || '',
                subscription_period: quotation.subscription_period || 12,
                total_amount_with_subscription: quotation.total_amount_with_subscription,
                subscription_amount: quotation.subscription_amount,
                deplyment_amount: quotation.deplyment_amount,
                brand_ids: (() => {
                    const bid = quotation.brand_id;
                    if (!bid) return [];
                    if (Array.isArray(bid)) return bid.map(id => parseInt(id));
                    if (typeof bid === 'string') {
                        try {
                            const parsed = JSON.parse(bid);
                            return Array.isArray(parsed) ? parsed.flat().map(id => parseInt(id)) : [parseInt(parsed)];
                        } catch (e) {
                            return bid.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
                        }
                    }
                    return [parseInt(bid)];
                })(),
                license_type_id: quotation.license_type_id || quotation.license_type?.name || '',
                deployment_type: quotation.deployment_type || '',
                model_type: quotation.model_type || '',
                license_discount_amount: quotation.license_discount_amount || '',
                service_discount_amount: quotation.service_discount_amount || '',
                license_discount_type: quotation.license_discount_type || '',
                service_discount_type: quotation.service_discount_type,
                transaction_type: quotation.transaction_type || '',
                partner_id: quotation.partner_id || '',
                partner_tier_id: quotation.partner_tier_id || '',
                margin_percentage: quotation.margin_percentage || ''
            });

            // ✅ FIX: Use the existing products data from state instead of API call
            const mergedProducts = quotation.product_item_details.map(item => {
                // Find the corresponding product in the existing products state
                const freshProduct = products.find(p => String(p.id) === String(item.product_id));
                // Fallback to the nested product from the quotation item if fresh product not found
                const productData = freshProduct || item.product || {};

                return {
                    product_id: item.product_id,
                    item_name: item.item_name,
                    item_description: item.item_description,
                    price: item?.price,
                    discount: item.discount || 0,
                    quantity: item.quantity || 0,
                    agents: item.agents || 1,
                    subtotal: item.price * (item.quantity || 1) * (item.agents || 1),
                    revenue_type: productData.revenue_type || item.product?.revenue_type,
                    // ✅ Use pricings from fresh product, or from the eager-loaded item.product
                    pricings: productData.pricings || item.pricings || [],
                    _product_raw: productData,
                };
            });

            setSelectedProducts(mergedProducts);

            // ✅ Load custom integration data if exists
            if (quotation.custom_integration_description || quotation.custom_integration_total) {
                setCustomIntegrationDescription(quotation.custom_integration_description || "");
                setCustomIntegrationTotal(quotation.custom_integration_total || 0);
            }
            if (quotation.editable_deployment_descriptions) {
                console.log('📥 Loading saved deployment descriptions:', quotation.editable_deployment_descriptions);
                setEditableDeploymentDescriptions(quotation.editable_deployment_descriptions);
            } else {
                // Initialize from product data if no saved descriptions exist
                const initialDescriptions = {};
                mergedProducts.forEach(product => {
                    if (product.deployment_description) {
                        initialDescriptions[product.product_id] = product.deployment_description;
                    }
                });
                setEditableDeploymentDescriptions(initialDescriptions);
            }

            // ✅ Load service descriptions if they exist
            if (quotation.editable_service_descriptions) {
                setEditableServiceDescriptions(quotation.editable_service_descriptions);
            }

            // ✅ Load deployment amounts if they exist - Handle if it's stored as an object mapping
            if (quotation.editable_deployment_amounts) {
                console.log('📥 Loading saved deployment amounts:', quotation.editable_deployment_amounts);
                let deploymentAmt = quotation.editable_deployment_amounts;
                if (typeof deploymentAmt === 'object' && deploymentAmt !== null) {
                    // It's a mapping of {productId: amount}, sum up all values
                    deploymentAmt = Object.values(deploymentAmt).reduce((acc, curr) => acc + (parseFloat(curr) || 0), 0);
                }
                setEditableDeploymentAmount(parseFloat(deploymentAmt) || 0);
            }
        } catch (error) {
            console.error('Error fetching quotation details:', error);
        } finally {
            setIsLoadingQuotation(false);
        }
    };

    // API functions
    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/brands`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setBrands(response.data.brand);
        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const allCategories = response.data.category;
            const allCategoriesList = allCategories.filter(cat => !cat.parent_id);
            const allSubcategories = allCategories.filter(cat => cat.parent_id);
            setCategories({ allCategoriesList, allSubcategories });
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchAMC = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");

            const res = await axios.get(`${backendUrl}/api/amc-settings`, {
                headers: {
                    Authorization: `Bearer ${userInfo?.token}`,
                    "Tenant-Origin": origin,
                },
                skipLoader: true,
            });

            const amcData = res.data?.data || res.data?.Data || res.data || [];
            setAmcList(Array.isArray(amcData) ? amcData : []);

        } catch (err) {
            console.error("Error fetching AMC settings:", err);
            setAmcList([]);
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/products`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            // setProducts(response.data.Data);
            let productsData = [];
            if (Array.isArray(response.data.Data)) {
                productsData = response.data.Data;
            } else if (response.data.Data && Array.isArray(response.data.Data.data)) {
                productsData = response.data.Data.data;
            } else if (response.data.data && Array.isArray(response.data.data)) {
                productsData = response.data.data;
            }
            
            setLocalProducts(productsData);
            if (setProducts) {
                setProducts(productsData);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };







    // useEffect(() => {
    //     console.log("🌀 Running product filter useEffect...");
    //     console.log("Model Type:", formData.model_type);
    //     console.log("Selected Products (before):", selectedProducts);

    //     let filtered = [];

    //     if (products && products.length > 0) {
    //         filtered = products.filter((product) => {
    //             const brandMatch =
    //                 !formData.brand_id || product.brand_id === parseInt(formData.brand_id);
    //             const licenseMatch =
    //                 !formData.license_type_id ||
    //                 product.categories?.some(
    //                     (c) => c.id === parseInt(formData.license_type_id)
    //                 );

    //             return brandMatch && licenseMatch;
    //         });

    //         // ✅ Add default channels ONLY if model_type = "new" - BOTH license and service products
    //         if (formData.model_type === "new") {
    //             const defaultChannels = products.filter((p) => {
    //                 const isDefaultChannel = p.is_default_channel === true;
    //                 const hasMatchingLicenseType = p.categories?.some(cat =>
    //                     cat.id === parseInt(formData.license_type_id)
    //                 );
    //                 return isDefaultChannel && hasMatchingLicenseType;
    //             });

    //             console.log("🧩 Default Channels Found (License & Service):", defaultChannels);

    //             defaultChannels.forEach((dc) => {
    //                 // Add to filtered list
    //                 if (!filtered.some((fp) => fp.id === dc.id)) {
    //                     filtered.push(dc);
    //                 }

    //                 // ✅ Auto-select if not already selected
    //                 const alreadySelected = selectedProducts.some(
    //                     (sp) => sp.product_id === dc.id
    //                 );

    //                 if (!alreadySelected) {
    //                     console.log("✅ Auto-selecting default product:", dc.product_name);

    //                     // ✅ FIX: Get the correct price based on selected license type
    //                     const selectedLicenseId = formData.license_type_id;
    //                     const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
    //                     const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

    //                     let matchedPricing = null;
    //                     if (Array.isArray(dc.pricings) && selectedLicenseName) {
    //                         matchedPricing = dc.pricings.find(p =>
    //                             String(p.license_model).toLowerCase() === selectedLicenseName
    //                         );
    //                     }

    //                     // ✅ FIX 2: Fallback to any available pricing if no specific match
    //                     if (!matchedPricing && Array.isArray(dc.pricings) && dc.pricings.length > 0) {
    //                         matchedPricing = dc.pricings[0];
    //                     }

    //                     const basePriceRaw = matchedPricing
    //                         ? (matchedPricing.price ?? matchedPricing.amount ?? null)
    //                         : dc.price || 0;

    //                     // ✅ FIX: Apply currency conversion to the price
    //                     const convertedPrice = convertPrice(basePriceRaw);

    //                     // Add to selectedProducts directly
    //                     setSelectedProducts((prev) => [
    //                         ...prev,
    //                         {
    //                             product_id: dc.id,
    //                             item_name: dc.product_name,
    //                             item_description: dc.description || "",
    //                             agents: 1, // 👈 ensure it's selected by default
    //                             quantity: 1,
    //                             price: Number(convertedPrice), // ✅ Use converted price
    //                             subtotal: Number(convertedPrice), // ✅ Use converted price for subtotal
    //                             is_default_channel: true,
    //                             revenue_type: dc.revenue_type,
    //                             product_type: dc.product_type,
    //                             pricings: dc.pricings || [],
    //                             _product_raw: dc, // ✅ Store the raw product data
    //                             license_model: selectedLicenseName, // ✅ Store the license model used
    //                         },
    //                     ]);
    //                 }
    //             });
    //         }

    //         // ✅ Always include already-selected products
    //         selectedProducts.forEach((sp) => {
    //             if (!filtered.some((fp) => fp.id === sp.product_id)) {
    //                 const fullProduct = products.find((p) => p.id === sp.product_id);
    //                 if (fullProduct) filtered.push(fullProduct);
    //             }
    //         });
    //     }

    //     console.log("Filtered Products (final):", filtered);
    //     setFilteredProducts(filtered);
    // }, [
    //     products,
    //     formData.brand_id,
    //     formData.license_type_id,
    //     formData.model_type,
    //     categories.allCategoriesList, // ✅ Add this dependency
    // ]);
    // Add these helper functions to separate products by type

    useEffect(() => {
        console.log("🌀 Running product filter useEffect...");
        console.log("Model Type:", formData.model_type);
        console.log("Selected Products (before):", selectedProducts);

        let filtered = [];

        if (localProducts && localProducts.length > 0) {
            const selectedLicenseId = formData.license_type_id;
            const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
            const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

            // ✅ FIX: Filter products based on product.license_type = "license" for Step 2
            filtered = localProducts.filter((product) => {
                const brandMatch = !formData.brand_ids || formData.brand_ids.length === 0 || formData.brand_ids.includes(parseInt(product.brand_id));
                const licenseMatch = !formData.license_type_id ||
                    product.categories?.some((c) => c.id === parseInt(formData.license_type_id)) ||
                    (selectedLicenseName && product.pricings?.some(p => String(p.license_model).toLowerCase() === selectedLicenseName));

                // ✅ ONLY show products with license_type = "license" in Step 2
                const isLicenseProduct = product.license_type?.toLowerCase() === "license";

                return brandMatch && licenseMatch && isLicenseProduct;
            });

            // ✅ Add default channels ONLY if model_type = "new" - based on pricing's is_default_channel
            if (formData.model_type === "new") {
                const selectedLicenseId = formData.license_type_id;
                const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
                const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

                console.log("🔍 Looking for default channels for license:", selectedLicenseName);

                const defaultChannels = localProducts.filter((product) => {
                    // ✅ Check if this is a license product AND has default channel pricing
                    const isLicenseProduct = product.license_type?.toLowerCase() === "license";
                    if (!isLicenseProduct || !Array.isArray(product.pricings) || product.pricings.length === 0) {
                        return false;
                    }

                    // Find pricing that matches the selected license AND is marked as default channel
                    const defaultPricingForLicense = product.pricings.find(pricing => {
                        const licenseModelMatch = String(pricing.license_model).toLowerCase() === selectedLicenseName;
                        const isDefaultChannel = pricing.is_default_channel === true;

                        return licenseModelMatch && isDefaultChannel;
                    });

                    return !!defaultPricingForLicense;
                });

                console.log("🧩 Default Channels Found for", selectedLicenseName + ":", defaultChannels);

                defaultChannels.forEach((dc) => {
                    // Add to filtered list if not already there
                    if (!filtered.some((fp) => fp.id === dc.id)) {
                        filtered.push(dc);
                    }

                    // ✅ Auto-select if not already selected
                    const alreadySelected = selectedProducts.some(
                        (sp) => sp.product_id === dc.id
                    );

                    if (!alreadySelected) {
                        console.log("✅ Auto-selecting default product:", dc.product_name);

                        // ✅ Get the specific pricing that is marked as default channel for this license
                        const selectedLicenseId = formData.license_type_id;
                        const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
                        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

                        // Find the default channel pricing for this license
                        const defaultPricing = dc.pricings.find(pricing => {
                            const licenseModelMatch = String(pricing.license_model).toLowerCase() === selectedLicenseName;
                            const isDefaultChannel = pricing.is_default_channel === true;
                            return licenseModelMatch && isDefaultChannel;
                        });

                        if (defaultPricing) {
                            const basePriceRaw = defaultPricing.price ?? defaultPricing.amount ?? 0;
                            const convertedPrice = convertPrice(basePriceRaw);

                            // Add to selectedProducts directly
                            setSelectedProducts((prev) => [
                                ...prev,
                                {
                                    product_id: dc.id,
                                    item_name: dc.product_name,
                                    item_description: dc.description || "",
                                    agents: 1,
                                    quantity: 1,
                                    price: Number(convertedPrice),
                                    subtotal: Number(convertedPrice),
                                    is_default_channel: true,
                                    revenue_type: dc.revenue_type,
                                    product_type: dc.product_type,
                                    pricings: dc.pricings || [],
                                    _product_raw: dc,
                                    license_model: selectedLicenseName,
                                    selected_pricing: defaultPricing,
                                },
                            ]);
                        } else {
                            console.warn("❌ No default pricing found for product:", dc.product_name);
                        }
                    }
                });
            }

            // ✅ Always include already-selected products (even if they don't match current filters)
            selectedProducts.forEach((sp) => {
                if (!filtered.some((fp) => fp.id === sp.product_id)) {
                    const fullProduct = localProducts.find((p) => p.id === sp.product_id);
                    if (fullProduct) filtered.push(fullProduct);
                }
            });
        }

        console.log("Filtered Products (final):", filtered);
        setFilteredProducts(filtered);
    }, [
        localProducts,
        formData.brand_ids,
        formData.license_type_id,
        formData.model_type,
        categories.allCategoriesList,
        selectedProducts,
    ]);
    const getLicenseProducts = () => {
        return selectedProducts.filter(product => {
            const productData = product._product_raw || product;
            const isLicenseType = productData.categories?.some(cat =>
                cat.licence_type?.toLowerCase() === 'license'
            ) || productData.license_type?.toLowerCase() === 'license' || productData.licence_type?.toLowerCase() === 'license';
            return isLicenseType;
            // ✅ This will include BOTH default channel and non-default channel license products
        });
    };

    const getServiceProducts = () => {
        return selectedProducts.filter(product => {
            const productData = product._product_raw || product;
            const isServiceType = productData.categories?.some(cat =>
                cat.licence_type?.toLowerCase() === 'service'
            ) || productData.license_type?.toLowerCase() === 'service' || productData.licence_type?.toLowerCase() === 'service';
            const isDefaultChannel = productData.is_default_channel === true;
            const isNewModel = formData.model_type === "new";

            return isServiceType && isDefaultChannel && isNewModel;
            // ✅ This will include ONLY default channel service products when model_type is "new"
        });
    };
    const fetchLastRefNo = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/quotation/ref-no`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
                params: { project_id: projectId },
            });
            setRefNo(response.data.ref_no);
            setFormData(prevData => ({
                ...prevData,
                ref_no: response.data.ref_no,
            }));
        } catch (error) {
            console.error('Error fetching last reference number:', error);
        }
    };

    const fetchTermsDetails = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/quotationterm`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const termDetails = response.data.quotation_terms.data.filter(term => term.type === 'quotation');
            if (termDetails.length > 0) {
                let notes = clientCurrency === 'AED'
                    ? termDetails[0]?.value_local || termDetails[0]?.value || ''
                    : clientCurrency === 'USD'
                        ? termDetails[0]?.value_export || termDetails[0]?.value || ''
                        : termDetails[0]?.value || '';

                notes = notes.replace(/{{currency}}/g, clientCurrency);
                setFormData(prevState => ({ ...prevState, notes }));
            }
        } catch (error) {
            console.error('Error fetching quotation terms:', error);
        }
    };
    // Update localProducts when products prop changes
    // Handle form changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // if (name === "model_type" && value === "new") {
        //     const defaultChannels = products.filter(p => p.is_default_channel);
        //     defaultChannels.forEach(product => handleProductSelect(product));
        // }
        // if (name === "model_type" && value === "new") {
        //     const defaultProducts = products.filter(p => p.is_default_channel);

        //     // Add them to selected products if not already there
        //     setSelectedProducts(prevSelected => {
        //         const newOnes = defaultProducts.filter(
        //             dp => !prevSelected.some(sp => sp.id === dp.id)
        //         );

        //         // Each with qty = 1 by default
        //         return [
        //             ...prevSelected,
        //             ...newOnes.map(p => ({ ...p, quantity: 1 })),
        //         ];
        //     });
        // }

        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };

    const handleEditorChange = (value) => {
        setFormData(prev => ({ ...prev, notes: value }));
    };

    // Product selection and management
    // const handleProductSelect = (product, initialAgents = 0, overridePrice = null) => {
    //     const selectedLicenseId = formData.license_type_id;
    //     const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
    //     const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;
    //     const productCurrency = product.currency || 'AED'; // Get product currency, default to AED

    //     let matchedPricing = null;
    //     if (Array.isArray(product.pricings) && selectedLicenseName) {
    //         matchedPricing = product.pricings.find(p =>
    //             String(p.license_model).toLowerCase() === selectedLicenseName
    //         );
    //     }

    //     // ✅ FIX 2: Show products for all license models including hybrid
    //     if (!matchedPricing && Array.isArray(product.pricings) && product.pricings.length > 0) {
    //         // If no specific license model match, use the first available pricing
    //         matchedPricing = product.pricings[0];
    //     }

    //     const basePriceRaw = overridePrice != null
    //         ? overridePrice
    //         : (matchedPricing && (matchedPricing.price ?? matchedPricing.amount ?? null))

    //         || 0;

    //     // const convertedPrice = convertPrice(basePriceRaw);
    //     const convertedPrice = convertPrice(basePriceRaw, productCurrency);


    //     const newProduct = {
    //         product_id: product.id,
    //         item_name: product.product_name,
    //         item_description: product.description || '',
    //         price: Number(convertedPrice),
    //         discount: product.discount_amount || 0,
    //         quantity: initialAgents || 0,
    //         agents: initialAgents || 1,
    //         subtotal: Number((Number(convertedPrice) * (initialAgents || 1)).toFixed(2)),
    //         revenue_type: product.revenue_type,
    //         product_type: product.product_type,
    //         pricings: matchedPricing ? [matchedPricing] : (Array.isArray(product.pricings) ? product.pricings : []),
    //         _product_raw: product,
    //         license_model: selectedLicenseName, // Store the license model
    //     };

    //     setSelectedProducts(prev => {
    //         const existsIndex = prev.findIndex(p => p.product_id === product.id);
    //         if (existsIndex !== -1) {
    //             const copy = [...prev];
    //             copy[existsIndex] = { ...copy[existsIndex], ...newProduct };
    //             return copy;
    //         }
    //         return [...prev, newProduct];
    //     });
    // };
    const handleProductSelect = (product, initialAgents = 0, overridePrice = null) => {
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        let matchedPricing = null;
        if (Array.isArray(product.pricings) && selectedLicenseName) {
            matchedPricing = product.pricings.find(p =>
                String(p.license_model).toLowerCase() === selectedLicenseName
            );
        }

        if (!matchedPricing && Array.isArray(product.pricings) && product.pricings.length > 0) {
            matchedPricing = product.pricings[0];
        }

        // ✅ PRICING LOGIC - License Model Based
        // Transaction Types: 'direct', 'partner', 'margin_based'
        // Use a helper to pick the first non-empty, non-null value
        const resolveType = (...vals) => vals.find(v => v && String(v).trim() !== '') || 'direct';
        let transactionType = resolveType(
            quotationData?.transaction_type,
            dealData?.transaction_type,
            formData?.transaction_type
        );

        const clientOrg = organisations?.find(org => String(org.id) === String(formData.client_id || dealData?.client_id));
        const isClientPartner = clientOrg?.org_type?.toLowerCase() === 'partner' || 
                                (dealData?.partner_name && dealData?.organisation?.name && dealData.partner_name === dealData.organisation.name && clientOrg?.contact_type?.toLowerCase() === 'client');

        if (isClientPartner) {
            transactionType = 'partner';
        }

        console.log('🔖 [Pricing] Resolved transactionType:', transactionType, {
            fromQuotationData: quotationData?.transaction_type,
            fromDealData: dealData?.transaction_type,
            fromFormData: formData?.transaction_type,
            isClientPartner
        });

        const resolvedClientId = formData.client_id || dealData?.client_id || quotationData?.client_id;
        const resolvedPartnerId = formData.partner_id || dealData?.partner_id || quotationData?.partner_id;

        const clientNameForLookup = clientOrg?.name || dealData?.organisation?.name || dealData?.client_name;
        const pricingPartnerOrg = organisations?.find(org => 
            org.name && clientNameForLookup && 
            org.name.toLowerCase() === clientNameForLookup.toLowerCase() && 
            (org.org_type?.toLowerCase() === 'partner' || org.contact_type?.toLowerCase() === 'client')
        );

        const partnerIdForPricing = (transactionType.toLowerCase() === 'partner' || !!resolvedPartnerId)
            ? (pricingPartnerOrg?.id || resolvedClientId)
            : null;

        let effectiveBasePriceRaw = null;
        let finalMatchedPricing = matchedPricing ? { ...matchedPricing } : null;

        if (finalMatchedPricing) {
            const standardPrice = Number(finalMatchedPricing.price || finalMatchedPricing.amount || 0);
            const override = partnerOverrides.find(ov => String(ov.product_pricing_id) === String(finalMatchedPricing.id));
            // ✅ ONLY use overrides for partner/customer specifics (old pricing.partner_price fields are ignored)
            if (override) {
                if (override.partner_price != null) finalMatchedPricing.partner_price = override.partner_price;
                if (override.end_customer_price != null) finalMatchedPricing.end_customer_price = override.end_customer_price;
                if (override.partner_deployment_price != null) finalMatchedPricing.deployment_cost = override.partner_deployment_price;
            } else {
                finalMatchedPricing.partner_price = null;
                finalMatchedPricing.end_customer_price = null;
            }

            // Use override if found, otherwise use global pricing values
            const partnerPriceRaw = finalMatchedPricing.partner_price;
            const endCustomerPriceRaw = finalMatchedPricing.end_customer_price;
            
            const partnerPrice = (partnerPriceRaw !== null && partnerPriceRaw !== undefined && Number(partnerPriceRaw) > 0)
                ? Number(partnerPriceRaw) : 0;
            const endCustomerPrice = (endCustomerPriceRaw !== null && endCustomerPriceRaw !== undefined && Number(endCustomerPriceRaw) > 0)
                ? Number(endCustomerPriceRaw) : 0;

            console.log('💵 [Pricing] Pricing source:', {
                isOverride: !!override,
                license_model: finalMatchedPricing.license_model,
                standard_price: standardPrice,
                partner_price: partnerPrice,
                end_customer_price: endCustomerPrice,
            });

            switch (transactionType.toLowerCase()) {
                case 'partner':
                    effectiveBasePriceRaw = partnerPrice > 0 ? partnerPrice : standardPrice;
                    console.log('💰 [Partner Mode] Using:', partnerPrice > 0 ? `Partner Price (${partnerPrice})` : `Standard Price Fallback (${standardPrice})`);
                    break;

                case 'margin_based':
                    effectiveBasePriceRaw = endCustomerPrice > 0 ? endCustomerPrice : standardPrice;
                    console.log('💰 [Margin Mode] Using:', endCustomerPrice > 0 ? `End Customer Price (${endCustomerPrice})` : `Standard Price Fallback (${standardPrice})`);
                    break;

                case 'direct':
                default:
                    effectiveBasePriceRaw = standardPrice;
                    console.log(`💰 [Direct Mode] Using: Standard Price (${standardPrice})`);
                    break;
            }
        }

        const basePriceRaw = overridePrice != null
            ? overridePrice
            : (effectiveBasePriceRaw !== null ? effectiveBasePriceRaw : (product.selling_price || product.price || 0));


        console.log('🔍 handleProductSelect - FINAL EFFECTIVE PRICE:', {
            product: product.product_name,
            transactionType,
            basePriceRaw,
            matchedPricingFound: !!matchedPricing
        });

        // Store the pre-filled price (stays editable in table)
        const productCurrency = getProductCurrency(product);
        const convertedPrice = convertPrice(basePriceRaw, productCurrency);
        const finalPrice = Number(convertedPrice);

        const newProduct = {
            product_id: product.id,
            item_name: product.product_name,
            item_description: product.description || '',
            price: Number(finalPrice),
            discount: product.discount_amount || 0,
            quantity: initialAgents || 0,
            agents: initialAgents || 1,
            subtotal: Number((Number(finalPrice) * (initialAgents || 1)).toFixed(2)),
            revenue_type: product.revenue_type,
            product_type: product.product_type,
            deployment_cost: (() => {
                if (!finalMatchedPricing) return 0;
                return Number(finalMatchedPricing.deployment_cost || 0);
            })(),
            pricings: finalMatchedPricing ? [finalMatchedPricing] : (Array.isArray(product.pricings) ? product.pricings : []),
            _product_raw: product,
            license_model: selectedLicenseName,
            selected_pricing: finalMatchedPricing,
            _debug: {
                transaction_type: transactionType,
                original_standard_price: matchedPricing?.price,
                partner_price_raw: matchedPricing?.partner_price,
                effective_price_used: basePriceRaw
            }
        };

        console.log('✅ [handleProductSelect] Final newProduct:', {
            name: newProduct.item_name,
            price: newProduct.price,
            transaction_type: transactionType,
        });

        setSelectedProducts(prev => {
            const existsIndex = prev.findIndex(p => p.product_id === product.id);
            if (existsIndex !== -1) {
                const copy = [...prev];
                copy[existsIndex] = { ...copy[existsIndex], ...newProduct };
                return copy;
            }
            return [...prev, newProduct];
        });
    };
    const handleProductRemove = (productId) => {
        setSelectedProducts(prev => prev.filter(p => p.product_id !== productId));
    };



    // const handleProductFieldChange = (productId, field, value) => {
    //     setSelectedProducts(prev => prev.map(product => {
    //         if (product.product_id === productId) {
    //             const updated = { ...product, [field]: value };

    //             if (field === 'price' || field === 'quantity' || field === 'agents') {
    //                 if (product.product_type === 'service') {
    //                     updated.subtotal = parseFloat(updated.price) * parseInt(updated.quantity) * parseInt(updated.agents);
    //                 } else {
    //                     updated.subtotal = parseFloat(updated.price) * parseInt(updated.quantity);
    //                 }
    //             }

    //             return updated;
    //         }
    //         return product;
    //     }));
    // };

    // const convertPrice = (price) => {
    //     if (price === undefined || price === null) return '0.00';
    //     const priceNumber = parseFloat(price);
    //     if (isNaN(priceNumber)) return '0.00';
    //     if (clientCurrency === 'USD') {
    //         return (priceNumber / usdToAedExchangeRate).toFixed(2);
    //     }
    //     return priceNumber.toFixed(2);
    // };

    // const handleProductFieldChange = (productId, field, value) => {
    //     setSelectedProducts(prev => prev.map(product => {
    //         if (product.product_id === productId) {
    //             const updated = { ...product, [field]: value };

    //             if (field === 'price' || field === 'quantity' || field === 'agents') {
    //                 const productCurrency = product._product_raw?.currency || 'AED';
    //                 const basePrice = parseFloat(updated.price);
    //                 const convertedPrice = parseFloat(convertPrice(basePrice, productCurrency));

    //                 if (product.product_type === 'service') {
    //                     updated.subtotal = convertedPrice * parseInt(updated.quantity) * parseInt(updated.agents);
    //                 } else {
    //                     updated.subtotal = convertedPrice * parseInt(updated.quantity);
    //                 }
    //             }

    //             return updated;
    //         }
    //         return product;
    //     }));
    // };

    const handleProductFieldChange = (productId, field, value) => {
        setSelectedProducts(prev => prev.map(product => {
            if (product.product_id === productId) {
                const updated = { ...product, [field]: value };

                if (field === 'price' || field === 'quantity' || field === 'agents') {
                    // FIX: Use the already converted price, don't convert again
                    const basePrice = parseFloat(updated.price);

                    if (product.product_type === 'service') {
                        updated.subtotal = basePrice * parseInt(updated.quantity) * parseInt(updated.agents);
                    } else {
                        updated.subtotal = basePrice * parseInt(updated.quantity);
                    }
                }

                return updated;
            }
            return product;
        }));
    };
    // const convertPrice = (price, productCurrency = 'AED') => {
    //     if (price === undefined || price === null) return '0.00';
    //     const priceNumber = parseFloat(price);
    //     if (isNaN(priceNumber)) return '0.00';

    //     // If client currency matches product currency, no conversion needed
    //     if (clientCurrency === productCurrency) {
    //         return priceNumber.toFixed(2);
    //     }

    //     // Convert from product currency to client currency
    //     if (productCurrency === 'AED' && clientCurrency === 'USD') {
    //         return (priceNumber / usdToAedExchangeRate).toFixed(2);
    //     } else if (productCurrency === 'USD' && clientCurrency === 'AED') {
    //         return (priceNumber * usdToAedExchangeRate).toFixed(2);
    //     }

    //     // Default: no conversion available
    //     return priceNumber.toFixed(2);
    // };

    //     const convertPrice = (price, productCurrency = 'AED') => {
    //         if (price === undefined || price === null) return '0.00';
    //         const priceNumber = parseFloat(price);
    //         if (isNaN(priceNumber)) return '0.00';
    //         console.log('🔄 convertPrice:', {
    //             price,
    //             productCurrency,
    //             currentCurrency,
    //             originalValue: priceNumber
    //         });

    //         // If client currency matches product currency, no conversion needed
    //         if (currentCurrency === productCurrency) {
    //             return priceNumber.toFixed(2);
    //         }

    //         // Convert from product currency to client currency
    //         // if (productCurrency === 'AED' && currentCurrency === 'USD') {
    //         //     return (priceNumber / usdToAedExchangeRate).toFixed(2);
    //         // } else if (productCurrency === 'USD' && currentCurrency === 'AED') {
    //         //     return (priceNumber * usdToAedExchangeRate).toFixed(2);
    //         // }
    //          if (productCurrency === 'AED' && currentCurrency === 'USD') {
    //     const converted = (priceNumber / usdToAedExchangeRate).toFixed(2);
    //     console.log('💱 AED to USD:', { priceNumber, converted });
    //     return converted;
    //   } else if (productCurrency === 'USD' && currentCurrency === 'AED') {
    //     const converted = (priceNumber * usdToAedExchangeRate).toFixed(2);
    //     console.log('💱 USD to AED:', { priceNumber, converted });
    //     return converted;
    //   }

    //         // Default: no conversion available
    //         return priceNumber.toFixed(2);
    //     };
    const getProductCurrency = (product) => {
        if (!product) return 'AED';
        // Handle both raw product objects and objects where product data is nested (e.g. in selectedProducts)
        const p = product._product_raw || product;
        return p.product_currency || p.currency || p.vendor?.currency || 'AED';
    };

    const convertPrice = (price, productCurrency = 'AED') => {
        if (price === undefined || price === null) return '0.00';
        const priceNumber = parseFloat(price);
        if (isNaN(priceNumber)) return '0.00';

        // Get dynamic exchange rate from localStorage
        const storedRate = localStorage.getItem('exchange_rate_usd_aed');
        const rate = storedRate ? parseFloat(storedRate) : 3.67;

        // If currencies match, no conversion needed
        if (productCurrency === currentCurrency) {
            return priceNumber.toFixed(2);
        }

        // Handle conversion scenarios
        if (productCurrency === 'AED' && currentCurrency === 'USD') {
            return (priceNumber / rate).toFixed(2);
        } else if (productCurrency === 'USD' && currentCurrency === 'AED') {
            return (priceNumber * rate).toFixed(2);
        }

        return priceNumber.toFixed(2);
    };

    const calculateSubscriptionTotal = () => {
        return selectedProducts.reduce((total, product) => {
            const hasSubscription = product.pricings?.some(
                (p) => p.license_model === 'subscription'
            ) || product.license_model === 'subscription';
            if (hasSubscription) {
                return total + parseFloat(product.subtotal || 0);
            }
            return total;
        }, 0);
    };

    const calculatePerpetualTotal = () => {
        return selectedProducts.reduce((total, product) => {
            const hasPerpetual = product.pricings?.some(
                (p) => p.license_model === 'perpetual'
            ) || product.license_model === 'perpetual';
            if (hasPerpetual) {
                return total + parseFloat(product.subtotal || 0);
            }
            return total;
        }, 0);
    };

    const calculateLicenseTotal = () => {
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        // ✅ FIX: Ensure we're working with numbers
        const total = selectedProducts.reduce((total, product) =>
            total + parseFloat(product.subtotal || 0), 0
        );

        return total;
    };

    // const calculateOneTimeTotal = () => {
    //     const selectedLicenseId = formData.license_type_id;
    //     const selectedLicenseObj = categories?.allCategoriesList?.find(
    //         (c) => String(c.id) === String(selectedLicenseId)
    //     );
    //     const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

    //     console.log('=== calculateOneTimeTotal Debug ===');
    //     console.log('selectedLicenseId:', selectedLicenseId);
    //     console.log('selectedLicenseName:', selectedLicenseName);
    //     console.log('selectedProducts:', selectedProducts);

    //     const total = selectedProducts.reduce((total, product) => {
    //         if (!Array.isArray(product.pricings) || product.pricings.length === 0) {
    //             console.log(`Product ${product.item_name}: No pricings array`);
    //             return total;
    //         }

    //         const matchedPricing = selectedLicenseName
    //             ? product.pricings.find(
    //                 (p) => String(p.license_model).toLowerCase() === selectedLicenseName
    //             )
    //             : product.pricings[0];

    //         console.log(`Product ${product.item_name}:`, {
    //             hasPricings: Array.isArray(product.pricings),
    //             pricingsCount: product.pricings?.length,
    //             matchedPricing: matchedPricing,
    //             deploymentCost: matchedPricing?.deployment_cost
    //         });

    //         const deploymentCost = matchedPricing
    //             ? parseFloat(matchedPricing.deployment_cost || 0)
    //             : 0;

    //         return total + deploymentCost;
    //     }, 0);

    //     console.log('Final oneTimeTotal:', total);
    //     console.log('=== End Debug ===');

    //     return total;
    // };

    const calculateOneTimeTotal = () => {
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        console.log('=== calculateOneTimeTotal ENHANCED DEBUG ===');

        const total = selectedProducts.reduce((total, product) => {
            if (!Array.isArray(product.pricings) || product.pricings.length === 0) {
                console.log(`Product ${product.item_name}: No pricings array`);
                return total;
            }

            let matchedPricing = null;
            if (selectedLicenseName) {
                matchedPricing = product.pricings.find(
                    (p) => String(p.license_model).toLowerCase() === selectedLicenseName
                );
            }

            // Fallback to first pricing if no exact match or no license name
            if (!matchedPricing && product.pricings.length > 0) {
                matchedPricing = product.pricings[0];
            }

            const deploymentCost = matchedPricing
                ? parseFloat(matchedPricing.deployment_cost || 0)
                : 0;

            // Get product currency for proper conversion
            const productCurrency = getProductCurrency(product);
            const convertedDeploymentCost = parseFloat(convertPrice(deploymentCost, productCurrency));

            console.log(`Product ${product.item_name}:`, {
                originalDeploymentCost: deploymentCost,
                productCurrency,
                convertedDeploymentCost,
                currentCurrency
            });

            return total + convertedDeploymentCost;
        }, 0);

        console.log('Final oneTimeTotal:', total);
        console.log('=== End Enhanced Debug ===');

        return total;
    };

    const calculateDiscountedAmount = (baseAmount) => {
        let discount = parseFloat(formData.discount_amount || 0);
        if (formData.discount_type === 'percentage') {
            discount = (discount / 100) * baseAmount;
        }
        return discount;
    };

    const calculateFinalTotal = () => {
        const licenseTotal = calculateLicenseTotal();
        const oneTimeTotal = calculateOneTimeTotal();
        const subscriptionPeriod = parseInt(formData.subscription_period || 12);
        const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);

        // Determine if we need to multiply by subscription period
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        let totalBeforeDiscount = 0;

        if (selectedLicenseName === 'subscription') {
            totalBeforeDiscount = (licenseTotal * subscriptionPeriod) + oneTimeTotal + customIntegrationTotalValue;
        } else {
            totalBeforeDiscount = licenseTotal + oneTimeTotal + customIntegrationTotalValue;
        }

        const discountAmount = calculateDiscountedAmount(totalBeforeDiscount);

        return (totalBeforeDiscount - discountAmount).toFixed(2);
    };
    const handleDownloadPDF = async () => {
        try {
            // Call your backend API to download PDF
            // This depends on your backend implementation
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            // Create download link
            // const downloadUrl = `${backendUrl}/api/quotations/${id}/download`;
            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob'
            });

            // Create blob and download
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Quotation_${formData.ref_no}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading PDF:', error);
        }
    };
    // Add this useEffect to debug modal state
    useEffect(() => {
        console.log('🔍 showPreviewModal state changed:', showPreviewModal);
    }, [showPreviewModal]);

    // Add this useEffect to debug modal state
    useEffect(() => {
        console.log('🔍 showPreviewModal state changed:', showPreviewModal);
        console.log('🔍 Current step:', currentStep);
        console.log('🔍 Loading state:', loading);
    }, [showPreviewModal, currentStep, loading]);

    // Also check if the modal component is receiving the prop correctly
    useEffect(() => {
        if (showPreviewModal) {
            console.log('🔍 QuotationPreviewModal should be visible with props:', {
                showPreviewModal,
                clientName,
                projectName,
                formData: formData.ref_no,
                selectedProductsCount: selectedProducts.length
            });
        }
    }, [showPreviewModal, clientName, projectName, formData, selectedProducts]);
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);

    //     try {
    //         const updatedProducts = selectedProducts.map(product => ({
    //             product_id: product.product_id,
    //             item_name: product.item_name,
    //             item_description: product.item_description,
    //             price: product.price,
    //             quantity: product.quantity,
    //             agents: product.agents || product.quantity,
    //             discount: product.discount,
    //             subtotal: product.subtotal,
    //             revenue_type: product.revenue_type,
    //             deployment_description: editableDeploymentDescriptions[product.product_id] ||
    //                 getProductDeploymentDescription(product)
    //         }));

    //         const subscriptionPeriod = parseInt(formData.subscription_period) || 12;
    //         const licenseTotal = calculateLicenseTotal();
    //         const updatedFormData = {
    //             ...formData,
    //             amount: calculateFinalTotal(),
    //             products: updatedProducts,
    //             subscription_period: subscriptionPeriod,
    //             total_amount_with_subscription: licenseTotal * subscriptionPeriod,
    //             subscription_amount: licenseTotal,
    //             deplyment_amount: calculateOneTimeTotal(),
    //             // ✅ FIX 3: Save integration and description in quotation
    //             custom_integration_description: customIntegrationDescription,
    //             custom_integration_total: customIntegrationTotal,
    //             editable_deployment_descriptions: JSON.stringify(editableDeploymentDescriptions),
    //             editable_service_descriptions: JSON.stringify(editableServiceDescriptions),


    //         };
    //         console.log('📦 Saving quotation with deployment data:', {
    //             editableDeploymentDescriptions,
    //             editableServiceDescriptions,
    //             editableDeploymentAmount,
    //             productsWithDeployment: updatedProducts.map(p => ({
    //                 name: p.item_name,
    //                 deployment_description: p.deployment_description
    //             }))
    //         });

    //         let apierrors;
    //         if (quotationId) {
    //             apierrors = await editQuotation(quotationId, updatedFormData);
    //         } else {
    //             apierrors = await addQuotation(updatedFormData);
    //         }

    //         if (apierrors && Object.keys(apierrors).length > 0) {
    //             setErrors(apierrors);
    //         } else {
    //             setErrors({});
    //             // setShowPreviewModal(true);
    //             setTimeout(() => {
    //                 console.log('🎯 Setting showPreviewModal to true');
    //                 setShowPreviewModal(true);
    //             }, 100);
    //             console.log('✅ Quotation saved, preview modal should open');


    //         }
    //     } catch (error) {
    //         console.error("An error occurred:", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // Update calculated values
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const updatedProducts = selectedProducts.map(product => ({
                product_id: product.product_id,
                item_name: product.item_name,
                item_description: product.item_description,
                price: product.price,
                quantity: product.quantity,
                agents: product.agents || product.quantity,
                discount: product.discount,
                subtotal: product.subtotal,
                revenue_type: product.revenue_type,
                deployment_description: editableDeploymentDescriptions[product.product_id] ||
                    getProductDeploymentDescription(product)
            }));

            const subscriptionPeriod = parseInt(formData.subscription_period) || 12;

            // Calculate the final costs from Step 5
            const licenseTotal = calculateLicenseTotal();
            const serviceAmount = calculateDeploymentConfigurationAmount();

            const individualDeploymentAmount = calculateOneTimeTotal();
            // const convertedIndividualDeploymentAmount = clientCurrency === 'USD'
            //     ? individualDeploymentAmount / usdToAedExchangeRate
            //     : individualDeploymentAmount;

            const convertedIndividualDeploymentAmount = individualDeploymentAmount;

            const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);

            const selectedLicenseId = formData.license_type_id;
            const selectedLicenseObj = categories?.allCategoriesList?.find(
                (c) => String(c.id) === String(selectedLicenseId)
            );
            const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

            let totalLicenseCost = licenseTotal;
            if (selectedLicenseName === 'subscription') {
                totalLicenseCost = licenseTotal * subscriptionPeriod;
            }

            // Calculate discounts (using the same logic from Step 5)
            const calculateLicenseDiscount = () => {
                const { license_discount_type = 'amount', license_discount_amount } = formData;
                if (!license_discount_amount) return 0;
                const discountType = license_discount_type || 'amount';
                return discountType === 'amount'
                    ? parseFloat(license_discount_amount)
                    : (license_discount_amount / 100) * totalLicenseCost;
            };

            const calculateServiceDiscount = () => {
                const { service_discount_type = 'amount', service_discount_amount } = formData;
                if (!service_discount_amount) return 0;
                const discountType = service_discount_type || 'amount';
                return discountType === 'amount'
                    ? parseFloat(service_discount_amount)
                    : (service_discount_amount / 100) * totalOneTimeCost;
            };

            const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;
            const licenseDiscountValue = calculateLicenseDiscount();
            const serviceDiscountValue = calculateServiceDiscount();

            // Calculate after-discount amounts (final amounts from Step 5)
            const finalLicenseCost = totalLicenseCost - licenseDiscountValue;
            const finalOneTimeCost = totalOneTimeCost - serviceDiscountValue;

            const subtotal = finalLicenseCost + finalOneTimeCost;

            const calculateDiscountedAmount = (amount) => {
                const { discount_type = 'amount', discount_amount } = formData;
                if (!discount_amount) return 0;
                const discountType = discount_type || 'amount';
                return discountType === 'amount'
                    ? parseFloat(discount_amount)
                    : (discount_amount / 100) * amount;
            };

            const overallDiscountValue = calculateDiscountedAmount(subtotal);
            const grandTotal = subtotal - overallDiscountValue;

            const clientOrg = organisations?.find(org => String(org.id) === String(formData.client_id || dealData?.client_id));
            const isClientPartner = clientOrg?.org_type?.toLowerCase() === 'partner' || 
                                    (dealData?.partner_name && dealData?.organisation?.name && dealData.partner_name === dealData.organisation.name && clientOrg?.contact_type?.toLowerCase() === 'client');
            
            const resolvedTransactionType = formData.transaction_type || dealData?.transaction_type || quotationData?.transaction_type || 'direct';
            const effectiveTransactionType = isClientPartner ? 'partner' : resolvedTransactionType;
            // In a 'partner' transaction, the pricing is fetched using the client_id
            const partnerIdForPricing = (effectiveTransactionType.toLowerCase() === 'partner' || formData.partner_id || dealData?.partner_id) 
                ? (formData.client_id || dealData?.client_id)
                : null;
            const finalPartnerId = (effectiveTransactionType.toLowerCase() === 'partner' || formData.partner_id || dealData?.partner_id) 
                ? (formData.client_id || dealData?.client_id) 
                : (formData.partner_id || dealData?.partner_id);

            const updatedFormData = {
                ...formData,
                transaction_type: effectiveTransactionType,
                partner_id: finalPartnerId,
                brand_id: formData.brand_ids, // Map plural to singular for backend
                amount: grandTotal, // Use the final grand total
                products: updatedProducts,
                subscription_period: subscriptionPeriod,
                // ✅ UPDATE: Use the final costs from Step 5
                total_amount_with_subscription: finalLicenseCost, // Final license cost after discounts
                subscription_amount: licenseTotal, // Monthly subscription if applicable
                deplyment_amount: finalOneTimeCost, // Final one-time cost after discounts
                service_amount: serviceAmount,
                custom_integration_description: customIntegrationDescription,
                custom_integration_total: customIntegrationTotal,
                editable_deployment_descriptions: JSON.stringify(editableDeploymentDescriptions),
                editable_service_descriptions: JSON.stringify(editableServiceDescriptions),
                editable_deployment_amounts: JSON.stringify(editableDeploymentAmount),
                amc_amount: calculateAMCAmount(),

            };

            console.log('📦 Saving quotation with final costs:', {
                finalLicenseCost,
                finalOneTimeCost,
                grandTotal,
                deployment_amount: updatedFormData.deplyment_amount,
                total_amount_with_subscription: updatedFormData.total_amount_with_subscription
            });

            let apierrors;
            if (quotationId) {
                apierrors = await editQuotation(quotationId, updatedFormData);
            } else {
                apierrors = await addQuotation(updatedFormData);
            }

            if (apierrors && Object.keys(apierrors).length > 0) {
                setErrors(apierrors);
            } else {
                setErrors({});
                setTimeout(() => {
                    console.log('🎯 Setting showPreviewModal to true');
                    setShowPreviewModal(true);
                }, 100);
                console.log('✅ Quotation saved, preview modal should open');
            }
        } catch (error) {
            console.error("An error occurred:", error);
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     if (selectedProducts.length > 0 || customIntegrationTotal > 0) {
    //         const subscriptionPeriod = parseInt(formData.subscription_period) || 12;
    //         const licenseTotal = calculateLicenseTotal();

    //         setFormData(prev => ({
    //             ...prev,
    //             subscription_amount: calculateSubscriptionTotal(),
    //             deplyment_amount: calculateOneTimeTotal(),
    //             total_amount_with_subscription: licenseTotal * subscriptionPeriod,
    //             amount: calculateFinalTotal()
    //         }));
    //     }
    // }, [formData.subscription_period, selectedProducts, formData.discount_amount, formData.discount_type, customIntegrationTotal]);

    // Update calculated values
    useEffect(() => {
        if (selectedProducts.length > 0 || customIntegrationTotal > 0) {
            const subscriptionPeriod = parseInt(formData.subscription_period) || 12;
            const licenseTotal = calculateLicenseTotal();
            const individualDeploymentAmount = calculateOneTimeTotal();
            const convertedIndividualDeploymentAmount = clientCurrency === 'USD'
                ? individualDeploymentAmount / usdToAedExchangeRate
                : individualDeploymentAmount;
            const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);

            const selectedLicenseId = formData.license_type_id;
            const selectedLicenseObj = categories?.allCategoriesList?.find(
                (c) => String(c.id) === String(selectedLicenseId)
            );
            const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

            let totalLicenseCost = licenseTotal;
            if (selectedLicenseName === 'subscription') {
                totalLicenseCost = licenseTotal * subscriptionPeriod;
            }

            const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;

            // Calculate discounts
            const calculateLicenseDiscount = () => {
                const { license_discount_type = 'amount', license_discount_amount } = formData;
                if (!license_discount_amount) return 0;
                const discountType = license_discount_type || 'amount';
                return discountType === 'amount'
                    ? parseFloat(license_discount_amount)
                    : (license_discount_amount / 100) * totalLicenseCost;
            };

            const calculateServiceDiscount = () => {
                const { service_discount_type = 'amount', service_discount_amount } = formData;
                if (!service_discount_amount) return 0;
                const discountType = service_discount_type || 'amount';
                return discountType === 'amount'
                    ? parseFloat(service_discount_amount)
                    : (service_discount_amount / 100) * totalOneTimeCost;
            };

            const licenseDiscountValue = calculateLicenseDiscount();
            const serviceDiscountValue = calculateServiceDiscount();

            const finalLicenseCost = totalLicenseCost - licenseDiscountValue;
            const finalOneTimeCost = totalOneTimeCost - serviceDiscountValue;

            const subtotal = finalLicenseCost + finalOneTimeCost;

            const calculateDiscountedAmount = (amount) => {
                const { discount_type = 'amount', discount_amount } = formData;
                if (!discount_amount) return 0;
                const discountType = discount_type || 'amount';
                return discountType === 'amount'
                    ? parseFloat(discount_amount)
                    : (discount_amount / 100) * amount;
            };

            const overallDiscountValue = calculateDiscountedAmount(subtotal);
            const grandTotal = subtotal - overallDiscountValue;

            setFormData(prev => ({
                ...prev,
                subscription_amount: selectedLicenseName === 'subscription' ? licenseTotal : 0,
                deplyment_amount: finalOneTimeCost, // Final one-time cost after discounts
                total_amount_with_subscription: finalLicenseCost, // Final license cost after discounts
                amount: grandTotal
            }));
        }
    }, [formData.subscription_period, selectedProducts, formData.discount_amount, formData.discount_type, formData.license_discount_amount, formData.license_discount_type, formData.service_discount_amount, formData.service_discount_type, customIntegrationTotal, editableDeploymentAmount]);
    const prevStep = () => {
        setCurrentStep(prev => prev - 1);
    };


    // ✅ FIX 4: Updated nextStep function with subscription period field
    const nextStep = () => {
        if (currentStep === 1) {
            if ((!formData.brand_ids || formData.brand_ids.length === 0) || !formData.license_type_id) {
                setErrors({ step1: 'Please select Brand and License Type' });
                return;
            }
            // } else if (currentStep === 2) {
            //     if (selectedProducts.length === 0) {
            //         setErrors({ step2: 'Please select at least one product' });
            //         return;
            //     }
        }
        setErrors({});
        setCurrentStep(prev => prev + 1);
    };
    const calculateSelectedProductsTotal = () => {
        return selectedProducts.reduce((total, product) => {
            return total + parseFloat(product.subtotal || 0);
        }, 0);
    };
    // Calculate AMC amount for perpetual licenses
    const calculateAMCAmount = () => {
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        if (selectedLicenseName !== "perpetual" || !formData.amc_percentage || !formData.amc_type) {
            return 0;
        }

        const perpetualTotal = calculatePerpetualTotal();
        const amcPercentage = parseFloat(formData.amc_percentage) || 0;

        return (perpetualTotal * amcPercentage) / 100;
    };

    // Calculate total perpetual amount including AMC
    const calculatePerpetualWithAMC = () => {
        const perpetualTotal = calculatePerpetualTotal();
        const amcAmount = calculateAMCAmount();
        return perpetualTotal + amcAmount;
    };
    // Step Progress Indicator
    const StepProgress = () => (
        <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center position-relative">
                {[1, 2, 3, 4, 5].map((step) => (
                    <div key={step} className="d-flex flex-column align-items-center">
                        <div
                            className={`rounded-circle d-flex align-items-center justify-content-center ${currentStep >= step
                                ? 'bg-primary text-white'
                                : 'bg-light border text-muted'
                                }`}
                            style={{
                                width: '30px',
                                height: '30px',
                                fontSize: '12px',
                                fontWeight: '600',
                                zIndex: 2
                            }}
                        >
                            {step}
                        </div>
                        <div
                            className="mt-2 text-center"
                            style={{
                                fontSize: '12px',
                                fontWeight: currentStep === step ? '600' : '400',
                                color: currentStep >= step ? '#000' : '#6c757d'
                            }}
                        >
                            {step === 1 && 'Configuration'}
                            {step === 2 && 'Products'}
                            {step === 3 && 'Additional Setup'}
                            {step === 4 && 'Summary'}
                            {step === 5 && 'Discount & Final'}
                        </div>
                    </div>
                ))}
                <div
                    className="position-absolute top-50 start-0 end-0"
                    style={{
                        height: '2px',
                        backgroundColor: '#e9ecef',
                        transform: 'translateY(-50%)',
                        zIndex: 1
                    }}
                ></div>
                <div
                    className="position-absolute top-50 start-0"
                    style={{
                        height: '2px',
                        backgroundColor: '#0d6efd',
                        transform: 'translateY(-50%)',
                        width: `${((currentStep - 1) / 4) * 100}%`,
                        zIndex: 1,
                        transition: 'width 0.3s ease'
                    }}
                ></div>
            </div>
        </div>
    );
    // Add this right after your convertPrice function
    // const displayPrice = (price) => {
    //     if (price === undefined || price === null) return '0.00';
    //     const priceNumber = parseFloat(price);
    //     if (isNaN(priceNumber)) return '0.00';

    //     if (clientCurrency === 'USD') {
    //         return (priceNumber / usdToAedExchangeRate).toFixed(2);
    //     }
    //     return priceNumber.toFixed(2);
    // };

    // const displayPrice = (price, productCurrency = 'AED') => {
    //     if (price === undefined || price === null) return '0.00';
    //     const priceNumber = parseFloat(price);
    //     if (isNaN(priceNumber)) return '0.00';

    //     return convertPrice(priceNumber, productCurrency);
    // };

    const displayPrice = (price, productCurrency = 'AED') => {
        if (price === undefined || price === null) return '0.00';
        const priceNumber = parseFloat(price);
        if (isNaN(priceNumber)) return '0.00';

        return convertPrice(priceNumber, productCurrency);
    };
    // Render steps
    const renderStep1 = () => {
        // Find selected license name
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(formData.license_type_id)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase() || "";

        return (
            <div>
                <h6 className="mb-3 text-dark fw-semibold">Product Configuration</h6>
                {errors.step1 && <div className="alert alert-danger py-2">{errors.step1}</div>}

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="brand" className="mb-3">
                            <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>Brand *</Form.Label>
                            <Select
                                isMulti
                                options={brands.map(brand => ({ value: brand.id, label: brand.name }))}
                                value={brands
                                    .filter(brand => formData.brand_ids?.some(bid => String(bid) === String(brand.id)))
                                    .map(brand => ({ value: brand.id, label: brand.name }))}
                                onChange={(selectedOptions) => {
                                    const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                    setFormData(prev => ({
                                        ...prev,
                                        brand_ids: selectedIds
                                    }));
                                    if (errors.step1) {
                                        setErrors(prevErrors => ({ ...prevErrors, step1: undefined }));
                                    }
                                }}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        fontSize: '13px',
                                        minHeight: '38px',
                                        borderRadius: '0.375rem',
                                        borderColor: '#dee2e6'
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        fontSize: '13px',
                                        zIndex: 9999
                                    })
                                }}
                                placeholder="Select Brands"
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group controlId="license_type" className="mb-3">
                            <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>License Type *</Form.Label>
                            <Form.Select
                                className="form-control"
                                style={{ fontSize: '13px', height: '38px' }}
                                name="license_type_id"
                                value={formData.license_type_id}
                                onChange={handleChange}
                            >
                                <option value="">Select License Type</option>
                                {categories.allCategoriesList.map(category => (
                                    <option key={category.id} value={category.id}>{category.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    {/* <Col md={6}>
                        <Form.Group controlId="deployment" className="mb-3">
                            <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>Deployment Type</Form.Label>
                            <Form.Select
                                className="form-control"
                                name="deployment_type"
                                value={formData.deployment_type}
                                onChange={handleChange}
                                style={{ fontSize: '13px', height: '38px' }}
                            >
                                <option value="">Select Deployment</option>
                                <option value="cloud">Cloud</option>
                                <option value="on-premise">On Premise</option>
                            </Form.Select>
                        </Form.Group>
                    </Col> */}

                    <Col md={6}>
                        <Form.Group controlId="model_type" className="mb-3">
                            <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>Model Type</Form.Label>
                            <Form.Select
                                className="form-control"
                                name="model_type"
                                value={formData.model_type}
                                onChange={handleChange}
                                style={{ fontSize: '13px', height: '38px' }}
                            >
                                <option value="">Select Model</option>
                                <option value="new">New</option>
                                <option value="expand">Expand</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                      <Col md={6}>
                        <Form.Group controlId="subscription_period">
                            <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>Subscription Period (Months)</Form.Label>
                            <Form.Control
                                type="number"
                                name="subscription_period"
                                value={formData.subscription_period}
                                onChange={handleChange}
                                min="1"
                                style={{ fontSize: '13px', height: '38px' }}
                            />
                        </Form.Group>
                    </Col>

                </Row>

                {/* <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="fw-medium text-muted" style={{ fontSize: "12px" }}>Transaction Type (from Deal)</Form.Label>
                            <div className="p-2 border rounded bg-light" style={{ fontSize: '13px', height: '38px', display: 'flex', alignItems: 'center' }}>
                                {formData.transaction_type ? (formData.transaction_type.charAt(0).toUpperCase() + formData.transaction_type.slice(1)) : 'Direct'}
                            </div>
                        </Form.Group>
                    </Col>

                    {(formData.partner_id || (formData.transaction_type?.toLowerCase() === 'partner' && (formData.client_id || dealData?.client_id))) && (
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="fw-medium text-muted" style={{ fontSize: "12px" }}>Partner Information</Form.Label>
                                <div className="p-2 border rounded bg-light" style={{ fontSize: '13px', height: '38px', display: 'flex', alignItems: 'center' }}>
                                    {organisations.find(org => String(org.id) === String(formData.partner_id || formData.client_id || dealData?.client_id))?.name || 'Partner Loaded'}
                                </div>
                            </Form.Group>
                        </Col>
                    )}
                </Row> */}


                <Row className="mb-4">
                  

                    {/* {selectedLicenseName === "perpetual" && (
                        <>
                            <Col md={6}>
                                <Form.Group controlId="amc_type">
                                    <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
                                        AMC Type
                                    </Form.Label>
                                    <Form.Select
                                        name="amc_type"
                                        value={formData.amc_type}
                                        onChange={handleChange}
                                        style={{ fontSize: "13px", height: "38px" }}
                                    >
                                        <option value="">Select AMC Type</option>
                                        <option value="standard">Standard</option>
                                        <option value="gold">Gold</option>
                                        <option value="platinum">Platinum</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="amc_percentage">
                                    <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
                                        AMC %
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="amc_percentage"
                                        value={formData.amc_percentage}
                                        onChange={handleChange}
                                        style={{ fontSize: "13px", height: "38px" }}
                                    />
                                </Form.Group>
                            </Col>

                        </>

                    )} */}
                    {selectedLicenseName === "perpetual" && (
                        <>
                            <Col md={6}>
                                <Form.Group controlId="amc_type">
                                    <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
                                        AMC Type *
                                    </Form.Label>
                                    <Form.Select
                                        name="amc_type"
                                        value={formData.amc_type}
                                        onChange={(e) => {
                                            const selectedAMC = amcList.find(amc => amc.amc_type === e.target.value);
                                            setFormData(prev => ({
                                                ...prev,
                                                amc_type: e.target.value,
                                                amc_percentage: selectedAMC ? selectedAMC.percentage : 0
                                            }));
                                        }}
                                        style={{ fontSize: "13px", height: "38px" }}
                                        required
                                    >
                                        <option value="">Select AMC Type</option>
                                        {amcList.map(amc => (
                                            <option key={amc.id} value={amc.type}>
                                                {amc.amc_type}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="amc_percentage_display">
                                    <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
                                        AMC Percentage
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData.amc_percentage ? `${formData.amc_percentage}%` : '0%'}
                                        readOnly
                                        className="bg-light"
                                        style={{ fontSize: "13px", height: "38px" }}
                                    />

                                </Form.Group>
                            </Col>
                        </>
                    )}
                </Row>

            </div >
        );
    };



    const debugProductSubtotals = () => {
        console.log('=== Product Subtotals Debug ===');
        selectedProducts.forEach((product, index) => {
            console.log(`Product ${index + 1}:`, {
                id: product.product_id,
                name: product.item_name,
                subtotal: product.subtotal,
                parsed: parseFloat(product.subtotal),
                isValid: !isNaN(parseFloat(product.subtotal))
            });
        });
        console.log('Total:', calculateSelectedProductsTotal());
        console.log('=== End Debug ===');
    };
    const debugPriceConversions = () => {
        console.log('=== ENHANCED PRICE CONVERSION DEBUG ===');
        console.log('🌍 Currency Context:', { currentCurrency, clientCurrency });

        selectedProducts.forEach((product, index) => {
            const productData = product._product_raw || product;
            const productCurrency = getProductCurrency(productData);

            console.log(`Product ${index + 1}:`, {
                name: product.item_name,
                productCurrency,
                storedPrice: product.price,
                subtotal: product.subtotal,
                expectedConversion: productCurrency !== currentCurrency ? 'YES' : 'NO',
                conversionRate: usdToAedExchangeRate,
                debugInfo: product._debug || 'No debug info'
            });

            // Test the conversion
            if (product._product_raw?.price) {
                const testConverted = convertPrice(product._product_raw.price, productCurrency);
                console.log(`   Conversion Test: ${product._product_raw.price} ${productCurrency} → ${testConverted} ${currentCurrency}`);
            }
        });

        const licenseTotal = calculateLicenseTotal();
        console.log('📊 License Total:', licenseTotal);
        console.log('💰 Selected Products Total:', calculateSelectedProductsTotal());
        console.log('=== END ENHANCED DEBUG ===');
    };

    // Call this in renderStep2() and renderStep4() to verify

    // Call this when you suspect issues
    // debugProductSubtotals();
    const renderStep2 = () => (
        <div>
            <h6 className="mb-3 text-dark fw-semibold">Product Selection</h6>
            {errors.step2 && <div className="alert alert-danger py-2">{errors.step2}</div>}
            {debugPriceConversions()}
            {filteredProducts.length > 0 ? (
                <div className="bg-white rounded">
                    <div className="mb-3 p-3 bg-light rounded">
                        <h6 className="mb-1 fw-medium">
                            Available Products:
                            <span className="text-primary ms-1">
                                {formData.brand_ids?.length > 0
                                    ? brands.filter(b => formData.brand_ids.includes(b.id)).map(b => b.name).join(', ')
                                    : 'All Brands'}
                            </span>
                            {' | '}
                            <span className="text-primary">
                                {categories.allCategoriesList.find(c => c.id == formData.license_type_id)?.name || 'All License Types'}
                            </span>
                        </h6>
                        <small className="text-muted">
                            {filteredProducts.length} product(s) found
                        </small>

                    </div>
                    {/* Enhanced Table Layout */}
                    <div className="table-responsive">
                        <table className="table table-bordered align-middle mb-0">
                            <thead className="table-sales-gradient">
                                <tr>
                                    <th style={{ width: "35%", fontSize: "13px" }} className="fw-medium py-2">Product Description</th>
                                    <th style={{ width: "15%", fontSize: "13px" }} className="fw-medium py-2 text-center">Unit Price ({currentCurrency})</th>
                                    <th style={{ width: "15%", fontSize: "13px" }} className="fw-medium py-2 text-center">Quantity</th>
                                    <th style={{ width: "20%", fontSize: "13px" }} className="fw-medium py-2 text-end">Amount ({currentCurrency})</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredProducts.map(product => {
                                    const selectedProduct = selectedProducts.find(p => p.product_id === product.id);
                                    const agentCount = selectedProduct ? selectedProduct.agents : 0;
                                    const quantity = selectedProduct ? selectedProduct.quantity : 0;

                                    // const getProductPrice = () => {
                                    //     if (formData.license_type_id && product.pricings?.length > 0) {
                                    //         const selectedLicense = categories.allCategoriesList.find(c => c.id == formData.license_type_id);
                                    //         if (selectedLicense) {
                                    //             const licenseModel = selectedLicense.name.toLowerCase();
                                    //             const pricing = product.pricings.find(p => p.license_model === licenseModel);
                                    //             if (pricing) {
                                    //                 const productCurrency = product.currency || 'AED';
                                    //                 return convertPrice(pricing.price, productCurrency);
                                    //             }
                                    //         }
                                    //     }
                                    //     // Fallback to any available pricing
                                    //     if (product.pricings?.length > 0) {
                                    //         const productCurrency = product.currency || 'AED';
                                    //         return convertPrice(product.pricings[0].price, productCurrency);
                                    //     }
                                    //     return 0;
                                    // };
                                    const getProductPrice = () => {
                                        let finalPriceRaw = 0;
                                        const productCurrency = getProductCurrency(product);

                                        const clientNameRaw = formData.client_name || dealData?.organisation?.name || dealData?.client_name || quotationData?.client_name || dealData?.organisation_name;
                                        const currentClientName = (clientNameRaw || '').trim();
                                        const clientMatch = organisations?.find(org => 
                                            (org.name || org.organisation_name || '').trim().toLowerCase() === currentClientName.toLowerCase() && 
                                            org.contact_type?.toLowerCase() === 'client'
                                        );
                                        const partnerMatch = organisations?.find(org => 
                                            (org.name || org.organisation_name || '').trim().toLowerCase() === currentClientName.toLowerCase() && 
                                            org.org_type?.toLowerCase() === 'partner'
                                        );
                                        const pricingPartnerOrg = clientMatch || partnerMatch;

                                        const resolveType = (...vals) => vals.find(v => v && String(v).trim() !== '') || 'direct';
                                        let transactionType = resolveType(
                                            quotationData?.transaction_type,
                                            dealData?.transaction_type,
                                            formData?.transaction_type
                                        );

                                        if (!!pricingPartnerOrg) {
                                            transactionType = 'partner';
                                        }

                                        let matchedPricing = null;
                                        if (formData.license_type_id && product.pricings?.length > 0) {
                                            const selectedLicense = categories.allCategoriesList.find(c => c.id == formData.license_type_id);
                                            if (selectedLicense) {
                                                const licenseModel = selectedLicense.name.toLowerCase();
                                                matchedPricing = product.pricings.find(p => p.license_model === licenseModel);
                                            }
                                        }

                                        // Fallback to any available pricing
                                        if (!matchedPricing && product.pricings?.length > 0) {
                                            matchedPricing = product.pricings[0];
                                        }

                                        if (matchedPricing) {
                                            const standardPrice = Number(matchedPricing.price || matchedPricing.amount || 0);

                                            // ✅ Check for partner overrides in render step too!
                                            const override = partnerOverrides.find(ov => String(ov.product_pricing_id) === String(matchedPricing.id));
                                            
                                            // ✅ EXCLUSIVELY use overrides for partner pricing (ignored legacy pricing.partner_price)
                                            const partnerPriceRaw = override ? override.partner_price : null;
                                            const endCustomerPriceRaw = override ? override.end_customer_price : null;

                                            const partnerPrice = (partnerPriceRaw != null && Number(partnerPriceRaw) > 0)
                                                ? Number(partnerPriceRaw) : 0;
                                            const endCustomerPrice = (endCustomerPriceRaw != null && Number(endCustomerPriceRaw) > 0)
                                                ? Number(endCustomerPriceRaw) : 0;

                                            switch (transactionType.toLowerCase()) {
                                                case 'partner':
                                                    finalPriceRaw = partnerPrice > 0 ? partnerPrice : standardPrice;
                                                    break;
                                                case 'margin_based':
                                                    finalPriceRaw = endCustomerPrice > 0 ? endCustomerPrice : standardPrice;
                                                    break;
                                                default:
                                                    finalPriceRaw = standardPrice;
                                                    break;
                                            }
                                        } else {
                                            finalPriceRaw = product.selling_price || product.price || 0;
                                        }

                                        return convertPrice(finalPriceRaw, productCurrency);
                                    };

                                    const productPrice = getProductPrice(); // This is already converted to client currency
                                    const subtotal = (agentCount * quantity * parseFloat(productPrice)).toFixed(2); // ✅ FIXED: Remove convertPrice here

                                    return (
                                        <tr key={product.id}>
                                            <td>
                                                <div>
                                                    <div className="fw-medium" style={{ fontSize: "13px" }}>{product.product_name}</div>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <span style={{ fontSize: "13px" }}>{productPrice}</span> {/* ✅ FIXED: Remove convertPrice here */}
                                            </td>
                                            <td className="text-center">
                                                <Form.Control
                                                    type="number"
                                                    value={quantity}
                                                    className='form-control quantity-input'
                                                    onChange={(e) => {
                                                        const newQuantity = parseInt(e.target.value) || 1;
                                                        if (selectedProduct) {
                                                            handleProductFieldChange(product.id, 'quantity', newQuantity);
                                                        } else if (newQuantity > 0) {
                                                            handleProductSelect(product, agentCount, productPrice);
                                                        }
                                                    }}
                                                    min="1"
                                                    size="sm"
                                                    style={{
                                                        width: '70px',
                                                        textAlign: 'center',
                                                        fontSize: '13px',
                                                        margin: '0 auto',
                                                        display: 'block'
                                                    }}
                                                />
                                            </td>
                                            <td className="text-end">
                                                {agentCount > 0 ? (
                                                    <span className="fw-medium" style={{ fontSize: "13px" }}>{subtotal}</span>
                                                ) : (
                                                    <span className="text-muted" style={{ fontSize: "13px" }}>—</span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* Enhanced Quick Summary */}
                    {selectedProducts.length > 0 && (
                        <div className="mt-3 p-3 bg-light rounded">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="fw-medium" style={{ fontSize: "13px" }}>Selected Products: {selectedProducts.length}</div>
                                </div>
                                <div className="col-md-3 text-center">
                                    <div className="fw-medium" style={{ fontSize: "13px" }}>
                                        Total Agents: <span className="text-primary">{selectedProducts.reduce((sum, p) => sum + (p.agents || 0), 0)}</span>
                                    </div>
                                </div>
                                <div className="col-md-3 text-center">
                                    {calculateSubscriptionTotal() > 0 && (
                                        <div className="fw-medium" style={{ fontSize: "13px" }}>
                                            Total: <span className="text-primary">{calculateSelectedProductsTotal().toFixed(2)} {currentCurrency}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className="text-center py-4 text-muted">
                    <i className="fa fa-box fa-2x mb-2"></i>
                    <p className="mb-1">No products found for the selected criteria</p>
                    <small>Please adjust your selections in Step 1</small>
                </div>
            )}
        </div>
    );


    // Helper function to get deployment cost for a product
    // const getProductDeploymentCost = (product) => {
    //     const selectedLicenseId = formData.license_type_id;
    //     const selectedLicenseObj = categories?.allCategoriesList?.find(
    //         (c) => String(c.id) === String(selectedLicenseId)
    //     );
    //     const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

    //     if (!Array.isArray(product.pricings) || product.pricings.length === 0) {
    //         return 0;
    //     }

    //     const matchedPricing = selectedLicenseName
    //         ? product.pricings.find(
    //             (p) => String(p.license_model).toLowerCase() === selectedLicenseName
    //         )
    //         : product.pricings[0];

    //     const deploymentCost = matchedPricing ? parseFloat(matchedPricing.deployment_cost || 0) : 0;
    //     // return parseFloat(convertPrice(deploymentCost));
    //     const productCurrency = product._product_raw?.currency || 'AED';
    //     return parseFloat(convertPrice(deploymentCost, productCurrency));

    // };
    const getProductDeploymentCost = (product) => {
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        if (!Array.isArray(product.pricings) || product.pricings.length === 0) {
            return 0;
        }

        let matchedPricing = null;
        if (selectedLicenseName) {
            matchedPricing = product.pricings.find(
                (p) => String(p.license_model).toLowerCase() === selectedLicenseName
            );
        }

        // Fallback to first pricing if no exact match or no license name
        if (!matchedPricing && product.pricings.length > 0) {
            matchedPricing = product.pricings[0];
        }

        let deploymentCost = 0;
        if (matchedPricing) {
            // ✅ Check for partner overrides for deployment cost too!
            const override = partnerOverrides.find(ov => String(ov.product_pricing_id) === String(matchedPricing.id));
            const overrideDeployment = override ? override.partner_deployment_price : null;

            deploymentCost = (overrideDeployment !== null && overrideDeployment !== undefined)
                ? Number(overrideDeployment)
                : Number(matchedPricing.deployment_cost || 0);
        }


        const productCurrency = getProductCurrency(product);
        const convertedCost = parseFloat(convertPrice(deploymentCost, productCurrency));

        console.log('🔧 Deployment Cost for:', product.item_name, {
            originalDeploymentCost: deploymentCost,
            productCurrency,
            convertedCost,
            isOverride: !!(partnerOverrides.find(ov => String(ov.product_pricing_id) === String(matchedPricing?.id)))
        });

        return convertedCost;
    };
    // Helper function to get deployment description for a product
    const getProductDeploymentDescription = (product) => {
        // You can customize this based on your product data structure
        // This could come from product.deployment_description or similar field
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        if (!Array.isArray(product.pricings) || product.pricings.length === 0) {
            return `${product.item_name} Setup`;
        }

        let matchedPricing = null;
        if (selectedLicenseName) {
            matchedPricing = product.pricings.find(
                (p) => String(p.license_model).toLowerCase() === selectedLicenseName
            );
        }

        // Fallback to first pricing if no exact match or no license name
        if (!matchedPricing && product.pricings.length > 0) {
            matchedPricing = product.pricings[0];
        }

        return matchedPricing?.deployment_description || `${product.item_name} Deployment & Configuration`;
    };







    // const getDefaultServices = () => {
    //     if (formData.model_type !== "new") {
    //         return [];
    //     }

    //     return products.filter(product => {
    //         // const isDefaultChannel = product.is_default_channel === true;
    //         const isServiceLicenseType = product.license_type?.toLowerCase() === "service";

    //         return isServiceLicenseType;
    //     });
    // };

    // const getDefaultServices = () => {
    //     if (formData.model_type !== "new") {
    //         return [];
    //     }

    //     return products.filter(product => {
    //         const isServiceLicenseType = product.license_type?.toLowerCase() === "service";

    //         // ✅ For default services, check if they have default channel pricing for the selected license
    //         if (formData.license_type_id) {
    //             const selectedLicenseId = formData.license_type_id;
    //             const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
    //             const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

    //             if (selectedLicenseName && Array.isArray(product.pricings)) {
    //                 const hasDefaultPricing = product.pricings.some(pricing => {
    //                     const licenseModelMatch = String(pricing.license_model).toLowerCase() === selectedLicenseName;
    //                     const isDefaultChannel = pricing.is_default_channel === true;
    //                     return licenseModelMatch && isDefaultChannel;
    //                 });

    //                 // ✅ Return service products that have default channel pricing for the selected license
    //                 return isServiceLicenseType && hasDefaultPricing;
    //             }
    //         }

    //         // ✅ If no license selected, return all service products
    //         return isServiceLicenseType;
    //     });
    // };

    // const getDefaultServices = () => {
    //     if (formData.model_type !== "new") {
    //         return [];
    //     }

    //     return products.filter(product => {
    //         const isServiceLicenseType = product.license_type?.toLowerCase() === "service";

    //         if (!isServiceLicenseType) return false;

    //         // ✅ If license type is selected, check if service has matching pricing
    //         if (formData.license_type_id) {
    //             const selectedLicenseId = formData.license_type_id;
    //             const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
    //             const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

    //             if (selectedLicenseName && Array.isArray(product.pricings)) {
    //                 const hasMatchingPricing = product.pricings.some(pricing => {
    //                     const licenseModelMatch = String(pricing.license_model).toLowerCase() === selectedLicenseName;
    //                     // ✅ Return true if license matches, regardless of is_default_channel value
    //                     return licenseModelMatch;
    //                 });

    //                 // ✅ Return service products that have ANY pricing matching the selected license
    //                 return hasMatchingPricing;
    //             }
    //         }

    //         // ✅ If no license selected, return all service products
    //         return true;
    //     });
    // };
    const getDefaultServices = () => {
        if (formData.model_type !== "new") {
            return [];
        }

        // ADD NULL CHECK HERE
        if (!localProducts || !Array.isArray(localProducts)) {
            return [];
        }

        return localProducts.filter(product => {
            // ADD NULL CHECK FOR PRODUCT
            if (!product) return false;

            const isServiceLicenseType = product.license_type?.toLowerCase() === "service";
            if (!isServiceLicenseType) return false;

            // ✅ If license type is selected, check if service has matching pricing
            if (formData.license_type_id) {
                const selectedLicenseId = formData.license_type_id;
                const selectedLicenseObj = categories?.allCategoriesList?.find(c => String(c.id) === String(selectedLicenseId));
                const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

                if (selectedLicenseName && Array.isArray(product.pricings)) {
                    const hasMatchingPricing = product.pricings.some(pricing => {
                        const licenseModelMatch = String(pricing.license_model).toLowerCase() === selectedLicenseName;
                        return licenseModelMatch;
                    });

                    return hasMatchingPricing;
                }
            }

            return true;
        });
    };
    const defaultServices = getDefaultServices();

    // NEW: Check if any selected product has service license type
    const hasServiceProducts = selectedProducts.some(product => {
        return product.categories?.some(cat =>
            cat.licence_type?.toLowerCase() === 'service'
        );
    });

    // const calculateDeploymentConfigurationAmount = () => {
    //     if (formData.model_type !== "new") return 0;

    //     const amount = defaultServices.reduce((total, service) => {
    //         let price = 0;
    //         if (Array.isArray(service.pricings) && service.pricings.length > 0) {
    //             price = service.pricings[0].price || service.pricings[0].amount || 0;
    //         }
    //         return total + parseFloat(price);
    //     }, 0);

    //     return parseFloat(convertPrice(amount));
    // };

    // ✅ Initialize editable amount when default services change
    // const calculateDeploymentConfigurationAmount = () => {
    //     if (formData.model_type !== "new") return 0;

    //     const selectedLicenseTypeId = formData.license_type_id;

    //     // Find selected license model name (like "subscription", "perpetual", etc.)
    //     const selectedLicenseTypeObj = categories?.allCategoriesList?.find(
    //         (c) => String(c.id) === String(selectedLicenseTypeId)
    //     );
    //     const selectedLicenseModel = selectedLicenseTypeObj?.name?.toLowerCase() || "";

    //     // Loop over all default service-type products
    //     const amount = defaultServices.reduce((total, service) => {
    //         // Only count service products
    //         if (service.license_type?.toLowerCase() !== "service") return total;

    //         let price = 0;

    //         // ✅ Match pricing array based on license model
    //         if (Array.isArray(service.pricings) && service.pricings.length > 0) {
    //             const matchingPricing = service.pricings.find(
    //                 (p) => p.license_model?.toLowerCase() === selectedLicenseModel
    //             );

    //             if (matchingPricing) {
    //                 price = Number(matchingPricing.price || matchingPricing.amount || 0);
    //             } else {
    //                 // ✅ fallback: if no matching license_model found, take 0
    //                 price = 0;
    //             }
    //         }

    //         return total + price;
    //     }, 0);

    //     const calculatedAmount = parseFloat(convertPrice(amount));

    //     // ✅ Save to formData
    //     // setFormData(prev => ({
    //     //     ...prev,
    //     //     service_amount: calculatedAmount
    //     // }));

    //     return calculatedAmount;
    // };

    // const calculateDeploymentConfigurationAmount = () => {
    //     if (formData.model_type !== "new") return 0;

    //     const selectedLicenseTypeId = formData.license_type_id;
    //     const selectedLicenseTypeObj = categories?.allCategoriesList?.find(
    //         (c) => String(c.id) === String(selectedLicenseTypeId)
    //     );
    //     const selectedLicenseModel = selectedLicenseTypeObj?.name?.toLowerCase() || "";

    //     const amount = defaultServices.reduce((total, service) => {
    //         if (service.license_type?.toLowerCase() !== "service") return total;

    //         let price = 0;

    //         if (Array.isArray(service.pricings) && service.pricings.length > 0) {
    //             const matchingPricing = service.pricings.find(
    //                 (p) => p.license_model?.toLowerCase() === selectedLicenseModel
    //             );

    //             if (matchingPricing) {
    //                 price = Number(matchingPricing.price || matchingPricing.amount || 0);
    //             }
    //         }

    //         const serviceCurrency = service.currency || 'AED';
    //         const convertedAmount = parseFloat(convertPrice(price, serviceCurrency));

    //         return total + convertedAmount;
    //     }, 0);

    //     return amount;
    // };

    const calculateDeploymentConfigurationAmount = () => {
        if (formData.model_type !== "new") return 0;

        const selectedLicenseTypeId = formData.license_type_id;
        const selectedLicenseTypeObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseTypeId)
        );
        const selectedLicenseModel = selectedLicenseTypeObj?.name?.toLowerCase() || "";

        console.log('🔧 Deployment Configuration Amount Calculation:', {
            selectedLicenseModel,
            defaultServicesCount: defaultServices.length
        });

        const amount = defaultServices.reduce((total, service) => {
            if (service.license_type?.toLowerCase() !== "service") return total;

            let price = 0;

            if (Array.isArray(service.pricings) && service.pricings.length > 0) {
                const matchingPricing = service.pricings.find(
                    (p) => p.license_model?.toLowerCase() === selectedLicenseModel
                );

                if (matchingPricing) {
                    price = Number(matchingPricing.price || matchingPricing.amount || 0);
                }
            }

            const serviceCurrency = service.currency || 'AED';
            const convertedAmount = parseFloat(convertPrice(price, serviceCurrency));

            console.log(`Service ${service.product_name}:`, {
                originalPrice: price,
                serviceCurrency,
                convertedAmount,
                currentCurrency
            });

            return total + convertedAmount;
        }, 0);

        console.log('Total Deployment Configuration Amount:', amount);
        return amount;
    };
    useEffect(() => {
        if (formData.model_type === "new" && defaultServices.length > 0) {
            const deploymentAmount = calculateDeploymentConfigurationAmount();

            setEditableDeploymentAmount(prev => {
                if (prev === 0 || prev === "" || isNaN(prev)) {
                    return deploymentAmount;
                }
                return prev;
            });
            setFormData(prev => ({
                ...prev,
                service_amount: deploymentAmount
            }));
        }
    }, [defaultServices, formData.model_type]);

    //    useEffect(() => {
    //     console.log('🔄 Step 3 useEffect running', {
    //         model_type: formData.model_type,
    //         defaultServicesLength: defaultServices.length,
    //         deploymentAmount: calculateDeploymentConfigurationAmount()
    //     });

    //     if (formData.model_type === "new" && defaultServices.length > 0) {
    //         const deploymentAmount = calculateDeploymentConfigurationAmount();

    //         console.log('📝 Setting deployment amount:', deploymentAmount);

    //         setEditableDeploymentAmount(prev => {
    //             const newValue = (prev === 0 || prev === "" || isNaN(prev)) ? deploymentAmount : prev;
    //             console.log('🔄 editableDeploymentAmount:', { prev, newValue });
    //             return newValue;
    //         });

    //         setFormData(prev => {
    //             if (prev.service_amount === deploymentAmount) {
    //                 console.log('⏭️ Skipping formData update - same value');
    //                 return prev;
    //             }
    //             console.log('✅ Updating formData service_amount');
    //             return {
    //                 ...prev,
    //                 service_amount: deploymentAmount
    //             };
    //         });
    //     }
    // }, [defaultServices, formData.model_type, calculateDeploymentConfigurationAmount]);

    // ✅ Initialize editable descriptions when products change
    useEffect(() => {
        const initialDescriptions = {};
        selectedProducts.forEach(product => {
            const deploymentCost = getProductDeploymentCost(product);
            if (deploymentCost > 0) {
                initialDescriptions[product.product_id] =
                    getProductDeploymentDescription(product) ||
                    `${product.item_name} Deployment & Configuration`;
            }
        });
        setEditableDeploymentDescriptions(initialDescriptions);
    }, [selectedProducts]);

    // ✅ Handle deployment description changes - move this outside renderStep3
    const handleDeploymentDescriptionChange = (productId, newDescription) => {
        setEditableDeploymentDescriptions(prev => ({
            ...prev,
            [productId]: newDescription
        }));
    };
    const handleServiceDescriptionChange = (productId, newDescription) => {
        setEditableServiceDescriptions(prev => ({
            ...prev,
            [productId]: newDescription
        }));
    };
    useEffect(() => {
        // Only initialize when defaultServices changes and no manual edits exist
        if (defaultServices.length > 0) {
            setEditableServiceDescriptions(prev => {
                const next = { ...prev };
                defaultServices.forEach(service => {
                    if (next[service.product_id] === undefined) {
                        next[service.product_id] = service.description
                            ? String(service.description)
                            : ` `;
                    }
                });
                return next;
            });
        }
    }, [defaultServices]);

    const safeToFixed = (value, decimals = 2) => {
        if (value === null || value === undefined) return '0.00';
        const num = parseFloat(value);
        return isNaN(num) ? '0.00' : num.toFixed(decimals);
    };
    const renderStep3 = () => {
        const individualDeploymentAmount = calculateOneTimeTotal();
        // const convertedIndividualDeploymentAmount = currentCurrency === 'USD'
        //     ? individualDeploymentAmount / usdToAedExchangeRate
        //     : individualDeploymentAmount;

        const convertedIndividualDeploymentAmount = individualDeploymentAmount;


        const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);

        const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;

        // Check if license type is service - FIXED: using licence_type field
        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const isServiceLicense = selectedLicenseObj?.licence_type?.toLowerCase() === 'service';

        // NEW: Check if any selected products are service type
        const hasAnyServiceProducts = isServiceLicense || hasServiceProducts;

        // Debug logging
        console.log('=== RENDER STEP 3 DEBUG ===');
        console.log('Selected license ID:', selectedLicenseId);
        console.log('Selected license object:', selectedLicenseObj);
        console.log('License type:', selectedLicenseObj?.licence_type);
        console.log('Is service license:', isServiceLicense);
        console.log('Has service products:', hasServiceProducts);
        console.log('Has any service products:', hasAnyServiceProducts);
        console.log('Default services:', defaultServices);
        console.log('Editable deployment amount:', editableDeploymentAmount);
        console.log('Individual deployment amount:', individualDeploymentAmount);
        console.log('Selected products:', selectedProducts);
        console.log('===========================');

        return (
            <div>
                <h6 className="mb-3 text-dark fw-semibold">Additional Setup (One-time)</h6>

                {/* ============================= SERVICE DEPLOYMENT COSTS TABLE ============================= */}
                {formData.model_type === "new" && !hasAnyServiceProducts && defaultServices.length > 0 && (
                    <div className="mb-4 border rounded">
                        <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#0f5194ff", fontSize: "14px" }}>
                            One-Time Deployment Configuration & Testing
                        </div>

                        <div className="p-3">
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                    <thead className="table-sales-gradient">
                                        <tr>
                                            <th style={{ fontSize: "12px", fontWeight: "bold" }}>Description</th>
                                            <th style={{ fontSize: "12px", fontWeight: "bold" }} className="text-end">Amount ({currentCurrency})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {defaultServices.map(service => {
                                            let serviceAmount = 0;

                                            // Get service amount with fallbacks
                                            if (Array.isArray(service.pricings) && service.pricings.length > 0) {
                                                // Match license_model with selected license type
                                                const selectedLicenseTypeObj = categories?.allCategoriesList?.find(
                                                    (c) => String(c.id) === String(formData.license_type_id)
                                                );
                                                const selectedLicenseModel = selectedLicenseTypeObj?.name?.toLowerCase() || "";

                                                const matchingPricing = service.pricings.find(
                                                    (p) => p.license_model?.toLowerCase() === selectedLicenseModel
                                                );

                                                if (matchingPricing) {
                                                    // ✅ EXCLUSIVELY use individual partner overrides for service pricing
                                                    const override = partnerOverrides.find(ov => String(ov.product_pricing_id) === String(matchingPricing.id));
                                                    
                                                    const partnerPriceRaw = override ? override.partner_price : null;
                                                    const partnerPrice = (partnerPriceRaw != null && Number(partnerPriceRaw) > 0) ? Number(partnerPriceRaw) : 0;
                                                    const standardPrice = Number(matchingPricing.price || matchingPricing.amount || 0);

                                                    const resolveType = (...vals) => vals.find(v => v && String(v).trim() !== '') || 'direct';
                                                    const transactionType = resolveType(
                                                        quotationData?.transaction_type,
                                                        dealData?.transaction_type,
                                                        formData?.transaction_type
                                                    );
                                                    
                                                    const clientOrg = organisations?.find(org => String(org.id) === String(formData.client_id || dealData?.client_id));
                                                    const isClientPartner = clientOrg?.org_type?.toLowerCase() === 'partner' || 
                                                                            (dealData?.partner_name && dealData?.organisation?.name && dealData.partner_name === dealData.organisation.name && clientOrg?.contact_type?.toLowerCase() === 'client');

                                                    let effectiveTransactionType = isClientPartner ? 'partner' : transactionType;

                                                    if (effectiveTransactionType.toLowerCase() === 'partner') {
                                                        serviceAmount = partnerPrice > 0 ? partnerPrice : standardPrice;
                                                    } else {
                                                        serviceAmount = standardPrice;
                                                    }
                                                }
                                            }


                                            const convertedAmount = parseFloat(convertPrice(serviceAmount));

                                            const currentDescription = editableServiceDescriptions[service.product_id] ||
                                                service.description;


                                            return (
                                                <tr key={service.product_id}>
                                                    <td className='text-start' style={{ fontSize: "11px" }}>
                                                        {/* <Form.Control
                                                            as="textarea"
                                                            rows={2}
                                                            value={editableServiceDescriptions[service.product_id || service.id] || service.description}
                                                            onChange={(e) => handleServiceDescriptionChange(service.product_id || service.id, e.target.value)}
                                                            style={{ fontSize: "12px" }}
                                                            placeholder="Enter service description..."
                                                        /> */}
                                                        {service.description}
                                                    </td>
                                                    <td style={{ fontSize: "12px" }} className="text-end">
                                                        {convertedAmount.toFixed(2)}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="1" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                Total Cost({currentCurrency})
                                            </td>
                                            <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                {calculateDeploymentConfigurationAmount().toFixed(2)}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                )}

                {/* ============================= REGULAR DEPLOYMENT CONFIGURATION (Non-service) ============================= */}
                {/* {formData.model_type === "new" && !hasAnyServiceProducts && defaultServices.length > 0 && (
                <div className="mb-4">
                    <div className="p-3">
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
                                Total Deployment Configuration & Testing Amount
                            </Form.Label>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                    type="number"
                                    value={editableDeploymentAmount}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setEditableDeploymentAmount(val === "" ? "" : Number(val));
                                    }}
                                    style={{ fontSize: "13px", height: "38px" }}
                                />
                                <span className="text-muted" style={{ fontSize: "13px" }}>{clientCurrency}</span>
                            </div>
                            <Form.Text className="text-muted">
                                Base amount: {calculateDeploymentConfigurationAmount().toFixed(2)} {clientCurrency}. You can edit this amount.
                            </Form.Text>
                        </Form.Group>
                    </div>
                </div>
            )} */}

                {/* ============================= INDIVIDUAL PRODUCT DEPLOYMENT COSTS ============================= */}
                {(individualDeploymentAmount > 0 || selectedProducts.some(p => getProductDeploymentCost(p) > 0)) && (
                    <div className="mb-4 border rounded">
                        <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#0f5194ff", fontSize: "14px" }}>
                            Product-Specific Deployment Costs
                        </div>

                        <div className="p-3">
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                    <thead className="table-sales-gradient">
                                        <tr>
                                            <th style={{ fontSize: "12px", fontWeight: "bold" }}>Deployment Description</th>
                                            <th style={{ fontSize: "12px", fontWeight: "bold" }} className="text-end">Amount ({currentCurrency})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedProducts.map(product => {
                                            const deploymentCost = getProductDeploymentCost(product);

                                            // Show product if it has deployment cost OR if it's a service product
                                            const isProductService = product.categories?.some(cat =>
                                                cat.licence_type?.toLowerCase() === 'service'
                                            );
                                            if (deploymentCost <= 0 && !isProductService) return null;

                                            const hasUserEdited = editableDeploymentDescriptions[product.product_id] !== undefined;
                                            const currentDescription = hasUserEdited
                                                ? editableDeploymentDescriptions[product.product_id]
                                                : (getProductDeploymentDescription(product) || `${product.item_name} ${isProductService ? 'Service' : 'Deployment & Configuration'}`);

                                            return (
                                                <tr key={product.product_id}>
                                                    {/* <td style={{ fontSize: "12px" }}>{product.item_name}</td> */}
                                                    <td style={{ fontSize: "12px" }}>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={2}
                                                            value={currentDescription || ''}
                                                            onChange={(e) => handleDeploymentDescriptionChange(product.product_id, e.target.value)}
                                                            style={{ fontSize: "12px" }}
                                                            placeholder="Enter deployment description..."
                                                        />
                                                    </td>
                                                    <td style={{ fontSize: "12px" }} className="text-end">
                                                        {deploymentCost.toFixed(2)}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    {individualDeploymentAmount > 0 && (
                                        <tfoot>
                                            <tr>
                                                <td colSpan="1" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                    Total Product Deployment Cost
                                                </td>
                                                <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                    {safeToFixed(individualDeploymentAmount)}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    )}
                                </table>
                            </div>
                        </div>
                    </div>
                )}

                {/* Show message if no deployment costs found */}
                {individualDeploymentAmount === 0 && defaultServices.length === 0 && (
                    <div className="alert alert-info">
                        <i className="fa fa-info-circle me-2"></i>
                        No deployment costs configured for selected products.
                    </div>
                )}

                {/* ============================= CUSTOM INTEGRATION SECTION ============================= */}
                {!hasAnyServiceProducts && (
                    <div className="mb-3 border rounded">
                        <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
                            Custom Integration
                        </div>
                        <div className="p-3">
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
                                    Integration Description
                                </Form.Label>
                                <ReactQuill
                                    theme="snow"
                                    value={customIntegrationDescription || ""}
                                    onChange={setCustomIntegrationDescription}
                                    style={{ height: "120px", marginBottom: "50px", fontSize: "13px" }}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
                                    Integration Cost
                                </Form.Label>
                                <div className="d-flex align-items-center gap-2">
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter additional integration cost"
                                        value={customIntegrationTotal || ""}
                                        onChange={(e) => setCustomIntegrationTotal(parseFloat(e.target.value) || 0)}
                                        style={{ fontSize: "13px", height: "38px" }}
                                    />
                                    <span className="text-muted" style={{ fontSize: "13px" }}>{currentCurrency}</span>
                                </div>
                            </Form.Group>
                        </div>
                    </div>
                )}

                {/* ============================= ONE-TIME COSTS SUMMARY ============================= */}
                <div className="p-3 bg-light rounded">
                    <h6 className="fw-semibold mb-2">One-Time Costs Summary</h6>

                    {formData.model_type === "new" && (parseFloat(editableDeploymentAmount) || 0) > 0 && !hasAnyServiceProducts && (
                        <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                            <span>Deployment Configuration & Testing:</span>
                            <span>{safeToFixed(editableDeploymentAmount)} {currentCurrency}</span>
                        </div>
                    )}

                    {formData.model_type === "new" && hasAnyServiceProducts && defaultServices.length > 0 && (
                        <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                            <span>Service Deployment Configuration:</span>
                            <span>{calculateDeploymentConfigurationAmount().toFixed(2)} {currentCurrency}</span>
                        </div>
                    )}

                    {individualDeploymentAmount > 0 && (
                        <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                            <span>Product Deployment Costs:</span>
                            <span>{safeToFixed(individualDeploymentAmount)} {currentCurrency}</span>
                        </div>
                    )}

                    {customIntegrationTotalValue > 0 && !hasAnyServiceProducts && (
                        <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                            <span>Custom Integration:</span>
                            <span>{customIntegrationTotalValue.toFixed(2)} {currentCurrency}</span>
                        </div>
                    )}

                    <div className="d-flex justify-content-between fw-bold pt-2 border-top" style={{ fontSize: "13px" }}>
                        <span>Total One-Time Cost:</span>
                        <span>{totalOneTimeCost.toFixed(2)} {currentCurrency}</span>
                    </div>
                </div>
            </div>
        );
    };

    const renderStep4 = () => {
        const licenseProducts = getLicenseProducts();
        const serviceProducts = getServiceProducts();
        { debugPriceConversions() };

        const licenseTotal = licenseProducts.reduce((total, product) =>
            total + parseFloat(product.subtotal || 0), 0
        );

        const serviceTotal = serviceProducts.reduce((total, product) =>
            total + parseFloat(product.subtotal || 0), 0
        );

        const oneTimeTotal = calculateOneTimeTotal();

        // const convertedIndividualDeploymentAmount = currentCurrency === 'USD'
        //     ? oneTimeTotal / usdToAedExchangeRate
        //     : oneTimeTotal;
        const convertedIndividualDeploymentAmount = oneTimeTotal;
        const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);
        const subscriptionPeriod = parseInt(formData.subscription_period || 12);

        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        let totalLicenseCost = licenseTotal;
        if (selectedLicenseName === 'subscription') {
            totalLicenseCost = licenseTotal * subscriptionPeriod;
        }

        const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;
        const subtotal = totalLicenseCost + totalOneTimeCost;

        const discountAmount = calculateDiscountedAmount(subtotal);
        const grandTotal = subtotal - discountAmount;

        const selectedBrand = brands?.find(b => b.id === Number(formData.brand_id))?.name || "Brand";

        const getAllDeploymentItems = () => {
            const items = [];

            // Add individual product deployments
            selectedProducts.forEach(product => {
                const deploymentCost = getProductDeploymentCost(product);
                if (deploymentCost > 0) {
                    const description = editableDeploymentDescriptions[product.product_id] ||
                        getProductDeploymentDescription(product) ||
                        `${product.item_name} Deployment & Configuration`;
                    items.push(description);
                }
            });

            // Add custom integration items
            if (customIntegrationDescription) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = customIntegrationDescription;

                const listItems = tempDiv.querySelectorAll('li, p, div');

                if (listItems.length > 0) {
                    listItems.forEach(item => {
                        const text = item.textContent?.trim();
                        if (text && text.length > 0) {
                            items.push(text);
                        }
                    });
                } else {
                    const lines = customIntegrationDescription.split(/<br\s*\/?>|<\/p>|<\/div>|\n|\•|\-/);
                    lines.forEach(line => {
                        const text = line.replace(/<[^>]*>/g, '').trim();
                        if (text && text.length > 0) {
                            items.push(text);
                        }
                    });
                }
            }

            return items;
        };

        const allDeploymentItems = getAllDeploymentItems();
        const customIntegrationTotalAmount = convertedIndividualDeploymentAmount + customIntegrationTotalValue;

        // ✅ FIX: Use only displayPrice for consistent formatting
        const safeToFixed = (value, decimals = 2) => {
            if (value === null || value === undefined) return '0.00';
            const num = parseFloat(value);
            return isNaN(num) ? '0.00' : num.toFixed(decimals);
        };

        return (
            <div>
                <h6 className="mb-3 text-dark fw-semibold">Quotation Summary</h6>

                {/* ============================= LICENSE SECTION ============================= */}
                {licenseProducts.length > 0 && (
                    <div className="mb-4 border rounded">
                        <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
                            {selectedBrand} - Licenses
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th style={{ width: "20%", fontSize: "12px", fontWeight: "bold" }}>Product</th>
                                        <th style={{ width: "40%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
                                        <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Qty</th>
                                        <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Unit Price ({currentCurrency})</th>
                                        <th style={{ width: "10%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Total ({currentCurrency})</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {licenseProducts.map((product, index) => (
                                        <tr key={index}>
                                            <td style={{ fontSize: "12px" }}>
                                                {product.item_name}

                                            </td>
                                            <td style={{ fontSize: "12px" }} className="text-start">{product.item_description || '-'}</td>
                                            <td style={{ fontSize: "12px" }} className="text-center">{product.quantity || 1}</td>
                                            <td style={{ fontSize: "12px" }} className="text-center">
                                                {/* ✅ FIX: Use safeToFixed instead of displayPrice to avoid double conversion */}
                                                {safeToFixed(product.price)}
                                            </td>
                                            <td style={{ fontSize: "12px" }} className="text-end">
                                                {/* ✅ FIX: Use safeToFixed instead of displayPrice to avoid double conversion */}
                                                {safeToFixed(product.subtotal)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            Total License Cost {selectedLicenseName === 'subscription' ? 'per month' : ''}
                                        </td>
                                        <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            {/* ✅ FIX: Use safeToFixed for totals */}
                                            {safeToFixed(licenseTotal)}
                                        </td>
                                    </tr>
                                    {selectedLicenseName === 'subscription' && (
                                        <tr>
                                            <td colSpan="4" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                Total License Cost per {subscriptionPeriod} months
                                            </td>
                                            <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                                {/* ✅ FIX: Use safeToFixed for totals */}
                                                {safeToFixed(licenseTotal * subscriptionPeriod)}
                                            </td>
                                        </tr>
                                    )}
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}

                {/* ============================= ONE-TIME & INTEGRATION SECTION ============================= */}
                {(serviceProducts.length > 0 || editableDeploymentAmount > 0 || customIntegrationTotalAmount > 0) && (
                    <div className="mb-4 border rounded">
                        <div className="py-2 px-3 text-white fw-semibold" style={{ backgroundColor: "#1e4b7a", fontSize: "14px" }}>
                            {selectedBrand} - Onboarding & Custom Integration
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th style={{ width: "65%", fontSize: "12px", fontWeight: "bold" }}>Description</th>
                                        <th style={{ width: "5%", fontSize: "12px", fontWeight: "bold" }}>QTY</th>
                                        <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-center">Price ({currentCurrency})</th>
                                        <th style={{ width: "15%", fontSize: "12px", fontWeight: "bold" }} className="text-end">Total ({currentCurrency})</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {serviceProducts.map((product, index) => (
                                        <tr key={`service-${index}`}>
                                            <td style={{ fontSize: "13px" }} className='text-start'>
                                                {product.item_name}
                                            </td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>1</td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>
                                                {safeToFixed(product.price)}
                                            </td>
                                            <td className="text-end" style={{ fontSize: "12px" }}>
                                                {safeToFixed(product.subtotal)}
                                            </td>
                                        </tr>
                                    ))} */}

                                    {/* ✅ One Time deployment, Configuration & Testing - Separate Row */}
                                    {editableDeploymentAmount > 0 && (
                                        <tr>
                                            <td style={{ fontSize: "13px" }} className='text-start'>
                                                One Time deployment, Configuration & Testing
                                            </td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>1</td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>
                                                {/* ✅ FIX: Use safeToFixed instead of displayPrice */}
                                                {safeToFixed(editableDeploymentAmount)}
                                            </td>
                                            <td className="text-end" style={{ fontSize: "12px" }}>
                                                {/* ✅ FIX: Use safeToFixed instead of displayPrice */}
                                                {safeToFixed(editableDeploymentAmount)}
                                            </td>
                                        </tr>
                                    )}

                                    {/* ✅ Custom Integration with Ordered List */}
                                    {customIntegrationTotalAmount > 0 && (
                                        <tr>
                                            <td className="text-start" style={{ fontSize: "13px" }}>
                                                <div className="fw-medium">Custom Integration</div>
                                                {allDeploymentItems.length > 0 && (
                                                    <div className="mt-2">
                                                        <ol className="mb-0" style={{ fontSize: "12px", paddingLeft: "20px" }}>
                                                            {allDeploymentItems.map((item, index) => (
                                                                <li key={index} className="text-muted">
                                                                    {item}
                                                                </li>
                                                            ))}
                                                        </ol>
                                                    </div>
                                                )}
                                            </td>
                                            <td className='text-center' style={{ fontSize: "12px" }}>1</td>
                                            <td className="text-center" style={{ fontSize: "12px" }}>
                                                {/* ✅ FIX: Use safeToFixed instead of displayPrice */}
                                                {safeToFixed(customIntegrationTotalAmount)}
                                            </td>
                                            <td className="text-end" style={{ fontSize: "12px" }}>
                                                {/* ✅ FIX: Use safeToFixed instead of displayPrice */}
                                                {safeToFixed(customIntegrationTotalAmount)}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="3" className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            Total One-time Cost ({currentCurrency})
                                        </td>
                                        <td className="text-end fw-medium" style={{ fontSize: "13px" }}>
                                            {/* ✅ FIX: Use safeToFixed instead of displayPrice */}
                                            {safeToFixed(totalOneTimeCost)}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // const renderStep5 = () => {
    //     const licenseTotal = calculateLicenseTotal();
    //     const individualDeploymentAmount = calculateOneTimeTotal();
    //     const convertedIndividualDeploymentAmount = clientCurrency === 'USD'
    //         ? individualDeploymentAmount / usdToAedExchangeRate
    //         : individualDeploymentAmount;

    //     const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);
    //     const subscriptionPeriod = parseInt(formData.subscription_period || 12);

    //     const selectedLicenseId = formData.license_type_id;
    //     const selectedLicenseObj = categories?.allCategoriesList?.find(
    //         (c) => String(c.id) === String(selectedLicenseId)
    //     );
    //     const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

    //     let totalLicenseCost = licenseTotal;
    //     if (selectedLicenseName === 'subscription') {
    //         totalLicenseCost = licenseTotal * subscriptionPeriod;
    //     }
    //     const calculateLicenseDiscount = () => {
    //         const { license_discount_type, license_discount_amount } = formData;
    //         if (!license_discount_amount) return 0;
    //         return license_discount_type === 'amount'
    //             ? parseFloat(license_discount_amount)
    //             : (license_discount_amount / 100) * totalLicenseCost;
    //     };

    //     // === Calculate Service Discount ===
    //     const calculateServiceDiscount = () => {
    //         const { service_discount_type, service_discount_amount } = formData;
    //         if (!service_discount_amount) return 0;
    //         return service_discount_type === 'amount'
    //             ? parseFloat(service_discount_amount)
    //             : (service_discount_amount / 100) * totalOneTimeCost;
    //     };
    //     const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;

    //     const licenseDiscountValue = calculateLicenseDiscount();
    //     const serviceDiscountValue = calculateServiceDiscount();

    //     const subtotal = (totalLicenseCost - licenseDiscountValue) + (totalOneTimeCost - serviceDiscountValue);
    //     const overallDiscountValue = calculateDiscountedAmount(subtotal);
    //     const grandTotal = subtotal - overallDiscountValue;


    //     // const subtotal = totalLicenseCost + totalOneTimeCost;
    //     const discountAmount = calculateDiscountedAmount(subtotal);
    //     // const grandTotal = subtotal - discountAmount;

    //     const safeToFixed = (value, decimals = 2) => {
    //         if (value === null || value === undefined) return '0.00';
    //         const num = parseFloat(value);
    //         return isNaN(num) ? '0.00' : num.toFixed(decimals);
    //     };

    //     // Calculate discount percentage from amount
    //     const calculateDiscountPercentage = (amount) => {
    //         if (!amount || subtotal <= 0) return 0;
    //         return ((amount / subtotal) * 100).toFixed(2);
    //     };

    //     // Handle discount input with validation
    //     // const handleDiscountChange = (e) => {
    //     //     const { name, value } = e.target;
    //     //     let numericValue = parseFloat(value) || 0;

    //     //     // Validation based on discount type
    //     //     if (name === "discount_amount") {
    //     //         if (formData.discount_type === 'amount') {
    //     //             // For amount type, don't allow more than subtotal
    //     //             if (numericValue > subtotal) {
    //     //                 numericValue = subtotal;
    //     //             }
    //     //         } else {
    //     //             // For percentage type, don't allow more than 100%
    //     //             if (numericValue > 100) {
    //     //                 numericValue = 100;
    //     //             }
    //     //         }
    //     //     }

    //     //     setFormData(prev => ({
    //     //         ...prev,
    //     //         [name]: numericValue
    //     //     }));
    //     // };
    //     const handleDiscountChange = (e) => {
    //         const { name, value } = e.target;

    //         // If the field is a type selector, save as string directly
    //         if (name.includes('_type') || name === 'discount_type') {
    //             setFormData(prev => ({
    //                 ...prev,
    //                 [name]: value
    //             }));
    //             return;
    //         }

    //         // Otherwise, it's a numeric input
    //         let numericValue = parseFloat(value) || 0;

    //         let maxValue = 0;
    //         let discountType = '';

    //         if (name.includes('license')) {
    //             discountType = formData.license_discount_type;
    //             maxValue = calculateLicenseTotal();
    //         } else if (name.includes('service')) {
    //             discountType = formData.service_discount_type;
    //             maxValue = editableDeploymentAmount + calculateOneTimeTotal() + (parseFloat(customIntegrationTotal) || 0);
    //         } else {
    //             discountType = formData.discount_type;
    //             maxValue = calculateLicenseTotal() + calculateOneTimeTotal();
    //         }

    //         if (name.includes('amount')) {
    //             if (discountType === 'amount' && numericValue > maxValue) numericValue = maxValue;
    //             if (discountType === 'percentage' && numericValue > 100) numericValue = 100;
    //         }

    //         setFormData(prev => ({
    //             ...prev,
    //             [name]: numericValue
    //         }));
    //     };



    //     // Get the equivalent percentage for display
    //     const equivalentPercentage = formData.discount_type === 'amount' && formData.discount_amount > 0
    //         ? calculateDiscountPercentage(formData.discount_amount)
    //         : null;

    //     return (
    //         <div>
    //             <h6 className="mb-3 text-dark fw-semibold">Discount & Final Summary</h6>

    //             {/* Discount Section */}
    //             <div className="mb-4">
    //                 <div className="py-2 px-3 text-black fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
    //                     Discount Configuration
    //                 </div>

    //                 <div className="p-3">
    //                     {/* <Row className="mb-3">
    //                         <Col md={6}>
    //                             <Form.Group controlId="discount_amount">
    //                                 <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>
    //                                     Discount {formData.discount_type === 'amount' ? `Amount (${clientCurrency})` : 'Percentage (%)'}
    //                                 </Form.Label>
    //                                 <Form.Control
    //                                     type="number"
    //                                     name="discount_amount"
    //                                     value={formData.discount_amount}
    //                                     onChange={handleDiscountChange}
    //                                     min="0"
    //                                     max={formData.discount_type === 'amount' ? subtotal : 100}
    //                                     step="0.01"
    //                                     style={{ fontSize: '13px', height: '38px' }}
    //                                     placeholder={formData.discount_type === 'amount' ? `Enter amount in ${clientCurrency}` : 'Enter percentage'}
    //                                 />
    //                                 {formData.discount_type === 'amount' && formData.discount_amount > 0 && equivalentPercentage && (
    //                                     <Form.Text className="text-muted" style={{ fontSize: '12px' }}>
    //                                         Equivalent to {equivalentPercentage}% of subtotal
    //                                     </Form.Text>
    //                                 )}
    //                                 {formData.discount_type === 'amount' && (
    //                                     <Form.Text className="text-muted" style={{ fontSize: '12px' }}>
    //                                         Maximum: {safeToFixed(subtotal)} {clientCurrency}
    //                                     </Form.Text>
    //                                 )}
    //                                 {formData.discount_type === 'percentage' && (
    //                                     <Form.Text className="text-muted" style={{ fontSize: '12px' }}>
    //                                         Maximum: 100%
    //                                     </Form.Text>
    //                                 )}
    //                             </Form.Group>
    //                         </Col>
    //                         <Col md={6}>
    //                             <Form.Group controlId="discount_type">
    //                                 <Form.Label className="fw-medium" style={{ fontSize: "13px" }}>Discount Type</Form.Label>
    //                                 <Form.Select
    //                                     name="discount_type"
    //                                     value={formData.discount_type}
    //                                     onChange={handleChange}
    //                                     style={{ fontSize: '13px', height: '38px' }}
    //                                 >
    //                                     <option value="amount">Amount ({clientCurrency})</option>
    //                                     <option value="percentage">Percentage (%)</option>
    //                                 </Form.Select>
    //                             </Form.Group>
    //                         </Col>
    //                     </Row> */}
    //                     {licenseTotal > 0 && (
    //                         <div className="mb-4 border rounded">
    //                             <div className="py-2 px-3 text-black fw-semibold bg-light" style={{ fontSize: "14px" }}>
    //                                 License Discount
    //                             </div>
    //                             <div className="p-3">
    //                                 <Row className="mb-3">
    //                                     <Col md={6}>
    //                                         <Form.Group controlId="license_discount_amount">
    //                                             <Form.Label style={{ fontSize: "13px" }}>
    //                                                 License Discount ({formData.license_discount_type === 'amount' ? clientCurrency : '%'})
    //                                             </Form.Label>
    //                                             <Form.Control
    //                                                 type="number"
    //                                                 name="license_discount_amount"
    //                                                 value={formData.license_discount_amount || ''}
    //                                                 onChange={handleDiscountChange}
    //                                                 placeholder="Enter discount"
    //                                                 style={{ fontSize: "13px" }}
    //                                             />
    //                                         </Form.Group>
    //                                     </Col>
    //                                     <Col md={6}>
    //                                         <Form.Group controlId="license_discount_type">
    //                                             <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
    //                                             <Form.Select
    //                                                 name="license_discount_type"
    //                                                 value={formData.license_discount_type || 'amount'}
    //                                                 onChange={handleDiscountChange}
    //                                                 style={{ fontSize: "13px" }}
    //                                             >
    //                                                 <option value="amount">Amount ({clientCurrency})</option>
    //                                                 <option value="percentage">Percentage (%)</option>
    //                                             </Form.Select>
    //                                         </Form.Group>
    //                                     </Col>
    //                                 </Row>
    //                                 {licenseDiscountValue > 0 && (
    //                                     <div className="text-muted" style={{ fontSize: "13px" }}>
    //                                         Discount Applied: -{safeToFixed(licenseDiscountValue)} {clientCurrency}
    //                                     </div>
    //                                 )}
    //                             </div>
    //                         </div>
    //                     )}
    //                     {totalOneTimeCost > 0 && (
    //                         <div className="mb-4 border rounded">
    //                             <div className="py-2 px-3 text-black fw-semibold bg-light" style={{ fontSize: "14px" }}>
    //                                 Service Discount
    //                             </div>
    //                             <div className="p-3">
    //                                 <Row className="mb-3">
    //                                     <Col md={6}>
    //                                         <Form.Group controlId="service_discount_amount">
    //                                             <Form.Label style={{ fontSize: "13px" }}>
    //                                                 Service Discount ({formData.service_discount_type === 'amount' ? clientCurrency : '%'})
    //                                             </Form.Label>
    //                                             <Form.Control
    //                                                 type="number"
    //                                                 name="service_discount_amount"
    //                                                 value={formData.service_discount_amount || ''}
    //                                                 onChange={handleDiscountChange}
    //                                                 placeholder="Enter discount"
    //                                                 style={{ fontSize: "13px" }}
    //                                             />
    //                                         </Form.Group>
    //                                     </Col>
    //                                     <Col md={6}>
    //                                         <Form.Group controlId="service_discount_type">
    //                                             <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
    //                                             <Form.Select
    //                                                 name="service_discount_type"
    //                                                 value={formData.service_discount_type || 'amount'}
    //                                                 onChange={handleDiscountChange}
    //                                                 style={{ fontSize: "13px" }}
    //                                             >
    //                                                 <option value="amount">Amount ({clientCurrency})</option>
    //                                                 <option value="percentage">Percentage (%)</option>
    //                                             </Form.Select>
    //                                         </Form.Group>
    //                                     </Col>
    //                                 </Row>
    //                                 {serviceDiscountValue > 0 && (
    //                                     <div className="text-muted" style={{ fontSize: "13px" }}>
    //                                         Discount Applied: -{safeToFixed(serviceDiscountValue)} {clientCurrency}
    //                                     </div>
    //                                 )}
    //                             </div>
    //                         </div>
    //                     )}

    //                     {/* === OVERALL DISCOUNT === */}
    //                     <div className="mb-4 border rounded">
    //                         <div className="py-2 px-3 text-black fw-semibold bg-light" style={{ fontSize: "14px" }}>
    //                             Overall Discount
    //                         </div>
    //                         <div className="p-3">
    //                             <Row className="mb-3">
    //                                 <Col md={6}>
    //                                     <Form.Group controlId="discount_amount">
    //                                         <Form.Label style={{ fontSize: "13px" }}>
    //                                             Discount ({formData.discount_type === 'amount' ? clientCurrency : '%'})
    //                                         </Form.Label>
    //                                         <Form.Control
    //                                             type="number"
    //                                             name="discount_amount"
    //                                             value={formData.discount_amount || ''}
    //                                             onChange={handleDiscountChange}
    //                                             placeholder="Enter discount"
    //                                             style={{ fontSize: "13px" }}
    //                                         />
    //                                     </Form.Group>
    //                                 </Col>
    //                                 <Col md={6}>
    //                                     <Form.Group controlId="discount_type">
    //                                         <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
    //                                         <Form.Select
    //                                             name="discount_type"
    //                                             value={formData.discount_type || 'amount'}
    //                                             onChange={handleDiscountChange}
    //                                             style={{ fontSize: "13px" }}
    //                                         >
    //                                             <option value="amount">Amount ({clientCurrency})</option>
    //                                             <option value="percentage">Percentage (%)</option>
    //                                         </Form.Select>
    //                                     </Form.Group>
    //                                 </Col>
    //                             </Row>
    //                             {overallDiscountValue > 0 && (
    //                                 <div className="text-muted" style={{ fontSize: "13px" }}>
    //                                     Discount Applied: -{safeToFixed(overallDiscountValue)} {clientCurrency}
    //                                 </div>
    //                             )}
    //                         </div>
    //                     </div>

    //                     {/* Discount Preview */}
    //                     {formData.discount_amount > 0 && (
    //                         <div className="alert alert-info py-2">
    //                             <div className="d-flex justify-content-between align-items-center">
    //                                 <span style={{ fontSize: "13px" }}>
    //                                     Discount Applied: {formData.discount_amount}
    //                                     {formData.discount_type === 'percentage' ? '%' : ` ${clientCurrency}`}
    //                                 </span>
    //                                 <span className="fw-bold" style={{ fontSize: "13px" }}>
    //                                     -{safeToFixed(discountAmount)} {clientCurrency}
    //                                 </span>
    //                             </div>
    //                             {formData.discount_type === 'amount' && equivalentPercentage && (
    //                                 <div style={{ fontSize: "12px" }} className="mt-1">
    //                                     <strong>Percentage:</strong> {equivalentPercentage}%
    //                                 </div>
    //                             )}
    //                             {formData.discount_type === 'percentage' && (
    //                                 <div style={{ fontSize: "12px" }} className="mt-1">
    //                                     <strong>Amount:</strong> {safeToFixed(discountAmount)} {clientCurrency}
    //                                 </div>
    //                             )}
    //                         </div>
    //                     )}
    //                 </div>
    //             </div>

    //             {/* Final Pricing Summary */}
    //             <div className="mb-4 border rounded">
    //                 <div className="py-2 px-3 text-black fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
    //                     Final Pricing Summary
    //                 </div>

    //                 <div className="p-3">
    //                     <div className="row mb-3">
    //                         <div className="col-md-12">
    //                             {/* ===== LICENSE COSTS ===== */}
    //                             <div className="fw-medium mb-2 text-dark" style={{ fontSize: "13px" }}>
    //                                 License Costs
    //                             </div>

    //                             <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
    //                                 <span>License Cost {selectedLicenseName === 'subscription' ? '(per month)' : ''}:</span>
    //                                 <span>{safeToFixed(licenseTotal)} {clientCurrency}</span>
    //                             </div>

    //                             {selectedLicenseName === 'subscription' && (
    //                                 <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
    //                                     <span>Total License Cost ({subscriptionPeriod} months):</span>
    //                                     <span>{safeToFixed(totalLicenseCost)} {clientCurrency}</span>
    //                                 </div>
    //                             )}

    //                             {/* ===== ONE-TIME COSTS ===== */}
    //                             <div className="fw-medium mt-3 mb-2 text-dark" style={{ fontSize: "13px" }}>
    //                                 One-Time Costs
    //                             </div>

    //                             <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
    //                                 <span>Deployment & Integration:</span>
    //                                 <span>{safeToFixed(totalOneTimeCost)} {clientCurrency}</span>
    //                             </div>
    //                         </div>
    //                     </div>

    //                     {/* ===== SUMMARY SECTION ===== */}
    //                     <div className="border-top pt-3">
    //                         <div className="d-flex justify-content-between mb-2" style={{ fontSize: "13px" }}>
    //                             <span>Subtotal:</span>
    //                             <span>{safeToFixed(subtotal)} {clientCurrency}</span>
    //                         </div>

    //                         {formData.discount_amount > 0 && (
    //                             <div className="d-flex justify-content-between text-danger mb-2" style={{ fontSize: "13px" }}>
    //                                 <span>Discount:</span>
    //                                 <span>-{safeToFixed(discountAmount)} {clientCurrency}</span>
    //                             </div>
    //                         )}

    //                         <div className="d-flex justify-content-between fw-bold pt-2 border-top" style={{ fontSize: "14px" }}>
    //                             <span>Grand Total:</span>
    //                             <span className="text-primary">{safeToFixed(grandTotal)} {clientCurrency}</span>
    //                         </div>
    //                     </div>
    //                 </div>

    //             </div>

    //             {/* Payment Terms */}
    //             <div className="mb-4">
    //                 <div className="py-2 px-3 text-black fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
    //                     Payment Terms & Conditions
    //                 </div>

    //                 <div className="p-2">
    //                     <Form.Group controlId="notes">
    //                         <ReactQuill
    //                             value={formData.notes}
    //                             onChange={handleEditorChange}
    //                             theme="snow"
    //                             style={{ height: '130px', fontSize: '13px' }}
    //                             placeholder="Enter payment terms, delivery terms, warranty information, and other conditions..."
    //                         />
    //                     </Form.Group>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // };

    const renderStep5 = () => {
        const licenseTotal = calculateLicenseTotal();
        const individualDeploymentAmount = calculateOneTimeTotal();
        // const convertedIndividualDeploymentAmount = currentCurrency === 'USD'
        //     ? individualDeploymentAmount / usdToAedExchangeRate
        //     : individualDeploymentAmount;
        const convertedIndividualDeploymentAmount = individualDeploymentAmount;


        const customIntegrationTotalValue = parseFloat(customIntegrationTotal || 0);
        const subscriptionPeriod = parseInt(formData.subscription_period || 12);

        const selectedLicenseId = formData.license_type_id;
        const selectedLicenseObj = categories?.allCategoriesList?.find(
            (c) => String(c.id) === String(selectedLicenseId)
        );
        const selectedLicenseName = selectedLicenseObj?.name?.toLowerCase?.() || null;

        let totalLicenseCost = licenseTotal;
        if (selectedLicenseName === 'subscription') {
            totalLicenseCost = licenseTotal * subscriptionPeriod;
        }

        // FIXED: Handle undefined/empty discount types with proper defaults
        const calculateLicenseDiscount = () => {
            const { license_discount_type = 'amount', license_discount_amount } = formData;
            if (!license_discount_amount) return 0;

            // Use 'amount' as default if type is not specified
            const discountType = license_discount_type || 'amount';
            return discountType === 'amount'
                ? parseFloat(license_discount_amount)
                : (license_discount_amount / 100) * totalLicenseCost;
        };

        // FIXED: Handle undefined/empty discount types with proper defaults
        const calculateServiceDiscount = () => {
            const { service_discount_type = 'amount', service_discount_amount } = formData;
            if (!service_discount_amount) return 0;

            // Use 'amount' as default if type is not specified
            const discountType = service_discount_type || 'amount';
            return discountType === 'amount'
                ? parseFloat(service_discount_amount)
                : (service_discount_amount / 100) * totalOneTimeCost;
        };

        const totalOneTimeCost = editableDeploymentAmount + convertedIndividualDeploymentAmount + customIntegrationTotalValue;

        const licenseDiscountValue = calculateLicenseDiscount();
        const serviceDiscountValue = calculateServiceDiscount();

        // Calculate after-discount amounts
        const licenseAfterDiscount = totalLicenseCost - licenseDiscountValue;
        const serviceAfterDiscount = totalOneTimeCost - serviceDiscountValue;

        const subtotal = licenseAfterDiscount + serviceAfterDiscount;

        // FIXED: Also ensure overall discount calculation handles undefined types
        const calculateDiscountedAmount = (amount) => {
            const { discount_type = 'amount', discount_amount } = formData;
            if (!discount_amount) return 0;

            const discountType = discount_type || 'amount';
            return discountType === 'amount'
                ? parseFloat(discount_amount)
                : (discount_amount / 100) * amount;
        };

        const overallDiscountValue = calculateDiscountedAmount(subtotal);
        const grandTotal = subtotal - overallDiscountValue;

        const safeToFixed = (value, decimals = 2) => {
            if (value === null || value === undefined) return '0.00';
            const num = parseFloat(value);
            return isNaN(num) ? '0.00' : num.toFixed(decimals);
        };

        // Calculate discount percentage from amount
        const calculateDiscountPercentage = (amount) => {
            if (!amount || subtotal <= 0) return 0;
            return ((amount / subtotal) * 100).toFixed(2);
        };

        // Handle discount input with validation
        const handleDiscountChange = (e) => {
            const { name, value } = e.target;

            // If the field is a type selector, save as string directly
            if (name.includes('_type') || name === 'discount_type') {
                setFormData(prev => ({
                    ...prev,
                    [name]: value
                }));
                return;
            }

            // Otherwise, it's a numeric input
            let numericValue = parseFloat(value) || 0;

            let maxValue = 0;
            let discountType = '';

            if (name.includes('license')) {
                discountType = formData.license_discount_type || 'amount'; // FIXED: Default to 'amount'
                maxValue = totalLicenseCost; // FIXED: Use totalLicenseCost instead of calculateLicenseTotal()
            } else if (name.includes('service')) {
                discountType = formData.service_discount_type || 'amount'; // FIXED: Default to 'amount'
                maxValue = totalOneTimeCost;
            } else {
                discountType = formData.discount_type || 'amount'; // FIXED: Default to 'amount'
                maxValue = subtotal;
            }

            if (name.includes('amount')) {
                if (discountType === 'amount' && numericValue > maxValue) numericValue = maxValue;
                if (discountType === 'percentage' && numericValue > 100) numericValue = 100;
            }

            setFormData(prev => ({
                ...prev,
                [name]: numericValue
            }));
        };

        // FIXED: Get discount types with defaults for display
        const licenseDiscountType = formData.license_discount_type || 'amount';
        const serviceDiscountType = formData.service_discount_type || 'amount';
        const overallDiscountType = formData.discount_type || 'amount';

        // Get the equivalent percentage for display
        const equivalentPercentage = overallDiscountType === 'amount' && formData.discount_amount > 0
            ? calculateDiscountPercentage(formData.discount_amount)
            : null;
        const amcAmount = calculateAMCAmount();
        const perpetualWithAMC = calculatePerpetualWithAMC();

        // Get the selected AMC type details for display
        const selectedAMCDetails = amcList?.find(amc => amc.amc_type === formData.amc_type);

        return (
            <div>
                <h6 className="mb-3 text-dark fw-semibold">Discount & Final Summary</h6>

                <div className="mb-4">
                    <div className="py-2 px-3 text-black fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
                        Discount Configuration
                    </div>

                    <div className="p-3">
                        {licenseTotal > 0 && (
                            <div className="mb-4 border rounded">
                                <div className="py-2 px-3 text-black fw-semibold bg-light" style={{ fontSize: "14px" }}>
                                    License Discount
                                </div>
                                <div className="p-3">
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Group controlId="license_discount_amount">
                                                <Form.Label style={{ fontSize: "13px" }}>
                                                    License Discount ({licenseDiscountType === 'amount' ? currentCurrency : '%'})
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="license_discount_amount"
                                                    value={formData.license_discount_amount || ''}
                                                    onChange={handleDiscountChange}
                                                    placeholder="Enter discount"
                                                    style={{ fontSize: "13px" }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="license_discount_type">
                                                <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
                                                <Form.Select
                                                    name="license_discount_type"
                                                    value={licenseDiscountType || 'amount'}
                                                    onChange={handleDiscountChange}
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    <option value="amount">Amount ({currentCurrency})</option>
                                                    <option value="percentage">Percentage (%)</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {licenseDiscountValue > 0 && (
                                        <div className="text-muted" style={{ fontSize: "13px" }}>
                                            Discount Applied: -{safeToFixed(licenseDiscountValue)} {currentCurrency}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {totalOneTimeCost > 0 && (
                            <div className="mb-4 border rounded">
                                <div className="py-2 px-3 text-black fw-semibold bg-light" style={{ fontSize: "14px" }}>
                                    Service Discount
                                </div>
                                <div className="p-3">
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Group controlId="service_discount_amount">
                                                <Form.Label style={{ fontSize: "13px" }}>
                                                    Service Discount ({serviceDiscountType === 'amount' ? currentCurrency : '%'})
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="service_discount_amount"
                                                    value={formData.service_discount_amount || ''}
                                                    onChange={handleDiscountChange}
                                                    placeholder="Enter discount"
                                                    style={{ fontSize: "13px" }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="service_discount_type">
                                                <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
                                                <Form.Select
                                                    name="service_discount_type"
                                                    value={serviceDiscountType || 'amount'}
                                                    onChange={handleDiscountChange}
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    <option value="amount">Amount ({currentCurrency})</option>
                                                    <option value="percentage">Percentage (%)</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {serviceDiscountValue > 0 && (
                                        <div className="text-muted" style={{ fontSize: "13px" }}>
                                            Discount Applied: -{safeToFixed(serviceDiscountValue)} {currentCurrency}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* === OVERALL DISCOUNT === */}
                        <div className="mb-4 border rounded">
                            <div className="py-2 px-3 text-black fw-semibold bg-light" style={{ fontSize: "14px" }}>
                                Overall Discount
                            </div>
                            <div className="p-3">
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group controlId="discount_amount">
                                            <Form.Label style={{ fontSize: "13px" }}>
                                                Discount ({overallDiscountType === 'amount' ? currentCurrency : '%'})
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="discount_amount"
                                                value={formData.discount_amount || ''}
                                                onChange={handleDiscountChange}
                                                placeholder="Enter discount"
                                                style={{ fontSize: "13px" }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="discount_type">
                                            <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
                                            <Form.Select
                                                name="discount_type"
                                                value={overallDiscountType || 'amount'}
                                                onChange={handleDiscountChange}
                                                style={{ fontSize: "13px" }}
                                            >
                                                <option value="amount">Amount ({currentCurrency})</option>
                                                <option value="percentage">Percentage (%)</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {overallDiscountValue > 0 && (
                                    <div className="text-muted" style={{ fontSize: "13px" }}>
                                        Discount Applied: -{safeToFixed(overallDiscountValue)} {currentCurrency}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Final Pricing Summary */}
                <div className="mb-4 border rounded">
                    <div className="py-2 px-3 text-black fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
                        Final Pricing Summary
                    </div>

                    <div className="p-3">
                        <div className="row mb-3">
                            <div className="col-md-12">
                                {/* ===== LICENSE COSTS ===== */}
                                <div className="fw-medium mb-2 text-dark" style={{ fontSize: "13px" }}>
                                    License Costs
                                </div>

                                <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                                    <span>License Cost {selectedLicenseName === 'subscription' ? '(per month)' : ''}:</span>
                                    <span>{safeToFixed(licenseTotal)} {currentCurrency}</span>
                                </div>
                                {selectedLicenseName === 'perpetual' && amcAmount > 0 && selectedAMCDetails && (
                                    <>

                                        <div className="d-flex justify-content-between mb-1 text-info" style={{ fontSize: "13px" }}>
                                            <span>
                                                AMC ({selectedAMCDetails.amc_type} - {formData.amc_percentage}%):
                                            </span>
                                            <span>+{safeToFixed(amcAmount)} {currentCurrency}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 fw-medium border-bottom pb-2" style={{ fontSize: "13px" }}>
                                            <span>Total with AMC:</span>
                                            <span>{safeToFixed(perpetualWithAMC)} {currentCurrency}</span>
                                        </div>
                                    </>
                                )}

                                {selectedLicenseName === 'subscription' && (
                                    <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                                        <span>Total License Cost ({subscriptionPeriod} months):</span>
                                        <span>{safeToFixed(totalLicenseCost)} {currentCurrency}</span>
                                    </div>
                                )}

                                {/* License Discount Display */}
                                {licenseDiscountValue > 0 && (
                                    <>
                                        <div className="d-flex justify-content-between mb-1 text-danger" style={{ fontSize: "13px" }}>
                                            <span>License Discount:</span>
                                            <span>-{safeToFixed(licenseDiscountValue)} {currentCurrency}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 fw-medium" style={{ fontSize: "13px" }}>
                                            <span>License After Discount:</span>
                                            <span className="text-success">{safeToFixed(licenseAfterDiscount)} {currentCurrency}</span>
                                        </div>
                                    </>
                                )}

                                {/* ===== ONE-TIME COSTS ===== */}
                                <div className="fw-medium mt-3 mb-2 text-dark" style={{ fontSize: "13px" }}>
                                    One-Time Costs
                                </div>

                                <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                                    <span>Deployment & Integration:</span>
                                    <span>{safeToFixed(totalOneTimeCost)} {currentCurrency}</span>
                                </div>

                                {/* Service Discount Display */}
                                {serviceDiscountValue > 0 && (
                                    <>
                                        <div className="d-flex justify-content-between mb-1 text-danger" style={{ fontSize: "13px" }}>
                                            <span>Service Discount:</span>
                                            <span>-{safeToFixed(serviceDiscountValue)} {currentCurrency}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2 fw-medium" style={{ fontSize: "13px" }}>
                                            <span>Services After Discount:</span>
                                            <span className="text-success">{safeToFixed(serviceAfterDiscount)} {currentCurrency}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* ===== SUMMARY SECTION ===== */}
                        <div className="border-top pt-3">
                            <div className="d-flex justify-content-between mb-2" style={{ fontSize: "13px" }}>
                                <span>Subtotal (After Individual Discounts):</span>
                                <span>{safeToFixed(subtotal)} {currentCurrency}</span>
                            </div>

                            {overallDiscountValue > 0 && (
                                <div className="d-flex justify-content-between text-danger mb-2" style={{ fontSize: "13px" }}>
                                    <span>Overall Discount:</span>
                                    <span>-{safeToFixed(overallDiscountValue)} {currentCurrency}</span>
                                </div>
                            )}

                            <div className="d-flex justify-content-between fw-bold pt-2 border-top" style={{ fontSize: "14px" }}>
                                <span>Grand Total:</span>
                                <span className="text-primary">{safeToFixed(grandTotal)} {currentCurrency}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Payment Terms */}
                <div className="mb-4">
                    <div className="py-2 px-3 text-black fw-semibold" style={{ backgroundColor: "#ffffff", fontSize: "14px" }}>
                        Payment Terms & Conditions
                    </div>

                    <div className="p-2">
                        <Form.Group controlId="notes">
                            <ReactQuill
                                value={formData.notes}
                                onChange={handleEditorChange}
                                theme="snow"
                                style={{ height: '130px', fontSize: '13px' }}
                                placeholder="Enter payment terms, delivery terms, warranty information, and other conditions..."
                            />
                        </Form.Group>
                    </div>
                </div>
            </div>
        );
    };

    const renderBasicInfo = () => {
        if (!isAllQuotationsPage) {
            // Original behavior for project-specific quotations
            return (
                <div className="mb-3 p-2 bg-light rounded">
                    <h6 className="mb-3 fw-semibold">Quotation Details</h6>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="client" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Client</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', height: '35px' }}
                                    type="text"
                                    value={clientName}
                                    readOnly
                                    className="bg-white"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="project" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Project</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', height: '35px' }}
                                    type="text"
                                    value={projectName}
                                    readOnly
                                    className="bg-white"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        {/* <Col md={6}>
                            <Form.Group controlId="ref_no" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Reference No.</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', height: '35px' }}
                                    type="text"
                                    name="ref_no"
                                    value={formData.ref_no}
                                    readOnly
                                    className="bg-white"
                                />
                            </Form.Group>
                        </Col> */}
                        <Col md={6}>
                            <Form.Group controlId="date" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Date *</Form.Label>
                                <DatePicker
                                    value={formData.date ? dayjs(formData.date) : null}
                                    onChange={(newValue) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            date: newValue ? newValue.format('YYYY-MM-DD') : ''
                                        }));
                                    }}
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            fullWidth: true,
                                            required: true,
                                            error: !!errors.date,
                                            sx: {
                                                '& .MuiInputBase-root': {
                                                    fontSize: '13px',
                                                    height: '35px',
                                                    backgroundColor: 'white'
                                                }
                                            }
                                        }
                                    }}
                                />
                                {errors.date && (
                                    <div className="text-danger" style={{ fontSize: '12px' }}>
                                        {errors.date}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            );
        } else {
            // New behavior for AllQuotations - show dropdowns
            return (
                <div className="mb-3 p-2 bg-light rounded">
                    <h6 className="mb-3 fw-semibold">Quotation Details</h6>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="client_id" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Client *</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', height: '35px' }}
                                    name="client_id"
                                    value={formData.client_id}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Client</option>
                                    {clients.map(client => (
                                        <option key={client.id} value={client.id}>
                                            {client.name}
                                        </option>
                                    ))}
                                </Form.Select>
                                {errors.client_id && (
                                    <div className="text-danger" style={{ fontSize: '12px' }}>
                                        {errors.client_id}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="project_id" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Project *</Form.Label>
                                <Form.Select
                                    style={{ fontSize: '13px', height: '35px' }}
                                    name="project_id"
                                    value={formData.project_id}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Project</option>
                                    {projects
                                        .filter(project => project.client_id == formData.client_id)
                                        .map(project => (
                                            <option key={project.id} value={project.id}>
                                                {project.name}
                                            </option>
                                        ))}
                                </Form.Select>
                                {errors.project_id && (
                                    <div className="text-danger" style={{ fontSize: '12px' }}>
                                        {errors.project_id}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="ref_no" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Reference No.</Form.Label>
                                <Form.Control
                                    style={{ fontSize: '13px', height: '35px' }}
                                    type="text"
                                    name="ref_no"
                                    value={formData.ref_no}
                                    readOnly
                                    className="bg-white"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="date" className="mb-3">
                                <Form.Label style={{ fontSize: "13px" }}>Date *</Form.Label>
                                <DatePicker
                                    value={formData.date ? dayjs(formData.date) : null}
                                    onChange={(newValue) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            date: newValue ? newValue.format('YYYY-MM-DD') : ''
                                        }));
                                    }}
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            fullWidth: true,
                                            required: true,
                                            error: !!errors.date,
                                            sx: {
                                                '& .MuiInputBase-root': {
                                                    fontSize: '13px',
                                                    height: '35px',
                                                    backgroundColor: 'white'
                                                }
                                            }
                                        }
                                    }}
                                />
                                {errors.date && (
                                    <div className="text-danger" style={{ fontSize: '12px' }}>
                                        {errors.date}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            );
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{ width: '1050px' }}>
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title className="fw-semibold">
                        {quotationId ? 'Edit Quotation' : 'Create New Quotation'}
                    </Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="p-4">
                    {/* Step Progress */}
                    <StepProgress />

                    <Form>
                        {/* ✅ MODIFIED: Basic Info - Only show in Steps 1-3, hide in Step 4 */}
                        {currentStep !== 4 && currentStep !== 3 && currentStep !== 5 && (
                            // <div className="mb-3 p-2 bg-light rounded">
                            //     <h6 className="mb-3 fw-semibold">Quotation Details</h6>
                            //     <Row>
                            //         <Col md={6}>
                            //             <Form.Group controlId="client" className="mb-3">
                            //                 <Form.Label style={{ fontSize: "13px" }}>Client</Form.Label>
                            //                 <Form.Control
                            //                     style={{ fontSize: '13px', height: '35px' }}
                            //                     type="text"
                            //                     value={clientName}
                            //                     readOnly
                            //                     className="bg-white"
                            //                 />
                            //             </Form.Group>
                            //         </Col>
                            //         <Col md={6}>
                            //             <Form.Group controlId="project" className="mb-3">
                            //                 <Form.Label style={{ fontSize: "13px" }}>Project</Form.Label>
                            //                 <Form.Control
                            //                     style={{ fontSize: '13px', height: '35px' }}
                            //                     type="text"
                            //                     value={projectName}
                            //                     readOnly
                            //                     className="bg-white"
                            //                 />
                            //             </Form.Group>
                            //         </Col>
                            //     </Row>
                            //     <Row>
                            //         <Col md={6}>
                            //             <Form.Group controlId="ref_no" className="mb-3">
                            //                 <Form.Label style={{ fontSize: "13px" }}>Reference No.</Form.Label>
                            //                 <Form.Control
                            //                     style={{ fontSize: '13px', height: '35px' }}
                            //                     type="text"
                            //                     name="ref_no"
                            //                     value={formData.ref_no}
                            //                     readOnly
                            //                     className="bg-white"
                            //                 />
                            //             </Form.Group>
                            //         </Col>
                            //         <Col md={6}>
                            //             <Form.Group controlId="date" className="mb-3">
                            //                 <Form.Label style={{ fontSize: "13px" }}>Date</Form.Label>
                            //                 <Form.Control
                            //                     style={{ fontSize: '13px', height: '35px' }}
                            //                     type="date"
                            //                     name="date"
                            //                     value={formData.date}
                            //                     onChange={handleChange}
                            //                     required
                            //                     className="form-control"
                            //                 />
                            //             </Form.Group>
                            //         </Col>
                            //     </Row>
                            // </div>
                            renderBasicInfo()
                        )}

                        {/* Step Content */}
                        <div className="step-content">
                            {currentStep === 1 && renderStep1()}
                            {currentStep === 2 && renderStep2()}
                            {currentStep === 3 && renderStep3()}
                            {currentStep === 4 && renderStep4()}
                            {currentStep === 5 && renderStep5()}
                        </div>
                    </Form>
                </Offcanvas.Body>

                {/* Navigation Buttons */}
                <div className="p-2 d-flex justify-content-between border-top bg-light">
                    <div>
                        {currentStep > 1 && (
                            <Button
                                variant="outline-secondary"
                                onClick={prevStep}
                                style={{ fontSize: '13px', padding: '6px 16px' }}
                            >
                                <i className="fa fa-arrow-left me-2"></i>
                                Previous
                            </Button>
                        )}
                    </div>
                    <div>
                        {currentStep < 5 ? (
                            <Button
                                variant="primary"
                                onClick={nextStep}
                                style={{ fontSize: '13px', padding: '6px 20px' }}
                            >
                                Next
                                <i className="fa fa-arrow-right ms-2"></i>
                            </Button>
                        ) : (
                            <Button
                                variant="success"
                                onClick={handleSubmit}
                                disabled={loading}
                                style={{ fontSize: '13px', padding: '6px 20px' }}
                            >
                                {loading && <Spinner animation="border" size="sm" className="me-2" />}
                                <i className="fa fa-check me-2"></i>
                                Save Quotation
                            </Button>
                        )}
                    </div>
                </div>
            </Offcanvas>

        </LocalizationProvider>
    );
};


export default QuotationForm;

